import { Box, Stack, Typography, Button, Checkbox, Select, MenuItem, RadioGroup, Radio, FormControlLabel, List, ListItem, Grid, FormLabel, Tooltip, Chip, Switch, FormGroup, FormControl, Avatar, Accordion, AccordionSummary, AccordionDetails, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { forwardRef, useEffect, useState } from 'react';
import rightCircle from '../../assets/images/icons/rightCircle.svg'
import { useDispatch, useSelector } from 'react-redux';
import { CAMPAIGN_BANNER_IMAGE_ALLOWED_DIMESHION, CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES, CAMPAIGN_TYPES, CAMPAIGN_TYPES_WITH_DETAILS, CAMPAIGNS_SUB_TYPES, capitalizeFirstLetter, citiesInIndia, DRAFT, FOLLOWERS_ARRAY, FORM_INPUTFIELD_STYLES, GENDER, LIVE, PERFORMANCE_CAMPAIGNS_SUB_TYPES, phonePreventText, PLATFORMS_IMGS_LIST, TOOLTIP_STYLES } from '../../utils/constant';
import { updateCampaign } from '../../pages/campaigns/campaignSlice';
import shopifyIcon from '../../assets/images/shopify.png'
import imageIcon from '../../assets/images/icons/imageIcon.svg'
import playIcon from '../../assets/images/icons/playIcon.svg'
import storyIcon from '../../assets/images/icons/storyIcon.svg'
import { DELIVERABLES_DATA, formatDate, getCostPrice, getDetailsValuesChecked, SELECTED_DELI, SELECTED_DELI_FOR_YOUTUBE } from '../../utils/common';
import AddIcon from '../../assets/images/icons/Add.svg'
import minusIcon from '../../assets/images/icons/Minus.svg'
import rightCaret from '../../assets/images/icons/rightCaret.svg'
import { Field, FieldArray, Form, Formik, getIn } from 'formik';
import Schema from "../../schema";
import AutoSuggestion from '../autocomplete';
import XWhite from '../../assets/images/icons/XWhite.svg'
import NormalInput from '../inputs/normalInput';
import BasicSelect from '../select';
import { getAllBrandForDropDown } from '../../pages/brands/action';
import Editor from "react-simple-wysiwyg";
import imageIconWhite from '../../assets/images/icons/ImageIconWhite.svg'
import check from '../../assets/images/icons/greenCheck.svg'
import deleteIconRed from '../../assets/images/icons/deleteIconRed.svg'
import NumberInput from '../inputs/normalInput/number';
import { addNewCampaign, getCampaignByIdForDetailsPage, getPresignedurl } from '../../pages/campaigns/action';
import playIconWhite from '../../assets/images/icons/playIconWhite.svg'
import videoModalIcon from '../../assets/images/icons/videomodalicon.svg'
import infoIcon from '../../assets/images/icons/infoIcon.svg'
import VideoplaybackDialogForCampaignModal from './VideoplaybackDialogForCampaignModal';
import stepsCheckModalIcon from '../../assets/images/icons/stepsCheckModalIcon.svg'
import rocketWhite from '../../assets/images/icons/RocketWhite.svg'
import fileIcon from '../../assets/images/icons/addListModal.svg'
import fileEditIcon from '../../assets/images/icons/editFile.svg'
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import InputAdornment from '@mui/material/InputAdornment';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import campaignInfluncerListBackground from '../../assets/images/icons/influncersCardCampaignBackground.svg'
import editIcon from '../../assets/images/icons/edit2.svg'
import { useDeleteInfluncersFromCampaignMutation } from '../../redux/api';
import instaCheckIcon from '../../assets/images/icons/instaCampaignChecked.svg'
import youtubeCheckIcon from '../../assets/images/icons/youtubeCampaignChecked.png'
import { ExpandMore } from '@mui/icons-material';
import dayjs from "dayjs";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import calenderIcon from '../../assets/images/icons/calendarIcon.svg'
import "./custom-datepicker.css";
import edit from '../../assets/images/icons/edit.svg'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  top: '0px',
  bottom: '0px',
  right: '0%',
  left: 'revert',
  border: '0px solid red',
  borderRadius: '16px', padding: '0px',
  backgroundRepeat: 'no-repeat',
  height: 'fit-content', width: 'fit-content',
  "& .MuiDialog-container": {
    margin: 0,
  },
  "& .MuiPaper-root": {
    margin: '0px !important',
    background: "white",
    border: '0px solid blue',
    borderRadius: '0px',
    maxWidth: '100dvw',
    maxHeight: '100dvh',
    height: '100dvh',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: '600px',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '800px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '975px',
    },
  },
}));
const CreateCampaignModal = (props) => {
  const { open, setOpen, influncersListForCampaign, handleAddInfluncersToCampaignsFromCurrentList = () => { } } = props;
  const [campaignStage, setCampaignStage] = useState(1);
  const [campaignInitialData, setCampaignInitialData] = useState({});
  const [isInfluncersDeletedFromCampaign, setIsInfluncersDeletedFromCampaign] = useState(false);
  const navigate = useNavigate();
  const {
    formData,
  } = useSelector((state) => state.campaignSlice);
  const dispatch = useDispatch();
  const handleClose = (resetForm) => {
    dispatch(updateCampaign({ formData: {} }));
    resetForm();
    setCampaignStage(1);
    setOpen(false)
  };
  useEffect(() => {
    setCampaignInitialData(formData)
  }, [formData])
  const validateSections = ({ dispatch, formData, campaignStage, handleChange, errors, touched, values, setFieldValue, setFieldTouched, handleBlur, setCampaignInitialData, setIsInfluncersDeletedFromCampaign, isInfluncersDeletedFromCampaign, setCampaignStage }) => {
    switch (campaignStage) {
      case 1:
        return <SectionOne dispatch={dispatch} formData={formData} handleChange={handleChange} errors={errors} values={values} setFieldValue={setFieldValue} />
      case 2:
        return <SectionTwo handleBlur={handleBlur} dispatch={dispatch} formData={formData} handleChange={handleChange} errors={errors} values={values} setFieldValue={setFieldValue} touched={touched} setFieldTouched={setFieldTouched} />
      case 3:
        return <SectionThree setFieldValue={setFieldValue} handleChange={handleChange} values={values} errors={errors} touched={touched} />
      case 4:
        return <SectionFour dispatch={dispatch} formData={formData} setFieldValue={setFieldValue} handleChange={handleChange} values={values} errors={errors} touched={touched} handleBlur={handleBlur} />
      case 5:
        return <SectionFive dispatch={dispatch} formData={formData} setFieldValue={setFieldValue} handleChange={handleChange} values={values} errors={errors} touched={touched} handleBlur={handleBlur} setCampaignStage={setCampaignStage} />
      case 6:
        return <SectionSix isInfluncersDeletedFromCampaign={isInfluncersDeletedFromCampaign} setIsInfluncersDeletedFromCampaign={setIsInfluncersDeletedFromCampaign} influncersListForCampaign={influncersListForCampaign} setCampaignInitialData={setCampaignInitialData} dispatch={dispatch} formData={formData} setFieldValue={setFieldValue} handleChange={handleChange} values={values} errors={errors} touched={touched} handleBlur={handleBlur} />
      case 7:
        return <SectionSeven isInfluncersDeletedFromCampaign={isInfluncersDeletedFromCampaign} setIsInfluncersDeletedFromCampaign={setIsInfluncersDeletedFromCampaign} influncersListForCampaign={influncersListForCampaign} setCampaignInitialData={setCampaignInitialData} dispatch={dispatch} formData={formData} setFieldValue={setFieldValue} handleChange={handleChange} values={values} errors={errors} touched={touched} handleBlur={handleBlur} />
      default:
        return null;
    }
  }
  return (
    <Formik
      initialValues={campaignInitialData}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={true}
      validationSchema={Schema.CampaignInfo}
      onSubmit={(values) => {
        dispatch(
          updateCampaign({
            formData: { ...formData, ...values, campaignApplyingPreferences: formData?.campaignApplyingPreferences || [] }
          })
        );
        if (formData?.campaignId) {
          values.campaignId = formData?.campaignId;
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
        setFieldValue,
        setFieldTouched,
        resetForm
      }) => {
        const validate = (campaignStage) => {
          switch (campaignStage) {
            case 1:
              if (!values?.type) {
                return false;
              }
              if (!values?.demand) {
                return false;
              }
              return true;
            case 2:
              const {
                type,
                trackingType,
                productLink,
                eventType,
                appsFlyerId,
                platform,
                selectedDeliverables = [],
                post = [],
                shipmentDetails = [],
                mode
              } = values;
              if (type === "affiliate") {
                if (!trackingType) return false;
                if (trackingType === "shopify") {
                  const isValidURL = /^https?:\/\/[^\s/$.?#].[^\s]*$/.test(productLink);
                  if (!productLink || !isValidURL) return false;
                  if (!eventType) return false;
                }
                if (trackingType === "appsFlyer") {
                  if (!appsFlyerId) return false;
                }
                return true;
              }
              if (!platform) return false;
              if (selectedDeliverables.length === 0) return false;
              const hasInvalidDeliverable = selectedDeliverables.some(
                (item) => !item?.post || item?.qty <= 0
              );
              if (hasInvalidDeliverable && mode !== "edit") return false;
              const isAnyPostTypeSelected =
                (post && post.length > 0) || (shipmentDetails && shipmentDetails.length > 0);
              if (isAnyPostTypeSelected && selectedDeliverables.length === 0) return false;
              return true;
            case 3:
              const { creatorLocation = [], influncerType = [], selectedCategories = [] } = values;
              if (
                creatorLocation.length === 0 ||
                influncerType.length === 0 ||
                selectedCategories.length === 0
              ) {
                return false;
              }
              return true;
            case 4:
              if (!values?.name) {
                return false;
              }
              if (!values?.brandId) {
                return false;
              }
              if (!values?.startDate) {
                return false;
              }
              if (values.startDate > values.endDate) {
                return false;
              }
              if (![CAMPAIGN_TYPES.AFFILIATE, CAMPAIGN_TYPES.PERFORMANCE].includes(values.type)) {
                if (!values?.endDate) {
                  return false;
                }
              }
              if (!values?.products || values.products.length === 0) {
                return false;
              }
              const invalidProduct = values.products.some(product =>
                !product.name || !product.link
              );
              if (invalidProduct) {
                return false;
              }
              if (!values?.bannerImageBase64 && values.mode !== 'edit') {
                return false;
              }
              if (!values?.brief) {
                return false;
              }
              return true;
            case 5:
              if (!values?.applyBydate ||
                !values?.conceptScriptDate ||
                !values?.contentSubmissionDate ||
                !values?.contentPublishDate) {
                return false;
              }
              if (!values?.budget ||
                !values?.budgetPerInfluencer ||
                !values?.noOfCreators) {
                return false;
              }
              if (values.type === CAMPAIGN_TYPES.PAID) {
                const totalMilestone =
                  Number(values.advancePayment || 0) +
                  Number(values.scriptApproval || 0) +
                  Number(values.contentApproval || 0) +
                  Number(values.linkApproval || 0);
                if (totalMilestone !== 100) {
                  return false;
                }
              }
              if (values.type === CAMPAIGN_TYPES.PERFORMANCE) {
                if (!values.costPer) {
                  return false;
                }
                if (values.costPer === "costPerShare" && !values.costPerShare) {
                  return false;
                }
                if (values.costPer === "costPerLinkClick" && !values.costPerLinkClick) {
                  return false;
                }
                if (values.costPer === "costPerView" && !values.costPerView) {
                  return false;
                }
                if (values.costPer === "costPerEngagement" && !values.costPerEngagement) {
                  return false;
                }
              }
              if (values.type === CAMPAIGN_TYPES.AFFILIATE) {
                if (!values.eventProgramPrice) {
                  return false;
                }
              }
              return true;
            case 6:
              if (!values.contactDetails) {
                return false;
              }
              const phoneRegex = /^\d{10}$/;
              if (!phoneRegex.test(values.contactDetails)) {
                return false;
              }
              return true;
            default:
              return true;
          }
        };
        return (
          <BootstrapDialog
            onClose={() => { handleClose(resetForm, values) }}
            aria-labelledby="customized-dialog-title"
            open={open}>
            <Form style={{ height: '100%' }}
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Box sx={{ padding: '15px 16px 15px 16px', height: '100%', border: '0px solid red', position: 'relative' }}>
                <Header setOpen={setOpen} campaignStage={campaignStage} navigate={navigate} formData={formData} />
                {campaignStage > 1 && campaignStage < 7 && <ProgressBar type={values.type} validate={validate} setCampaignStage={setCampaignStage} campaignStage={campaignStage} />}
                <Box sx={{
                  maxHeight: campaignStage > 1 && campaignStage < 7 ? '76%' : '83%', minHeight: campaignStage > 1 && campaignStage < 7 ? '76%' : '83%', overflowX: 'hidden', overflowY: 'scroll', scrollbarWidth: 'none', zIndex: 1,
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  }
                }}>
                  {validateSections({ campaignStage, handleChange, errors, touched, values, formData, dispatch, setFieldValue, setFieldTouched, handleBlur, setCampaignInitialData, setIsInfluncersDeletedFromCampaign, isInfluncersDeletedFromCampaign, setCampaignStage })}
                </Box>
                <Footer isInfluncersDeletedFromCampaign={isInfluncersDeletedFromCampaign} setOpen={setOpen} handleAddInfluncersToCampaignsFromCurrentList={handleAddInfluncersToCampaignsFromCurrentList} formData={formData} dispatch={dispatch} validate={validate} setCampaignStage={setCampaignStage} campaignStage={campaignStage} values={values} errors={errors} navigate={navigate} />
              </Box></Form></BootstrapDialog>)
      }}</Formik>
  )
}
export default CreateCampaignModal;
const Header = ({ campaignStage, navigate, formData, setOpen }) => {
  return (
    <>
      <Box sx={{
        height: '10%', borderBottom: '0px solid #F0F0F0'
      }}>
        <Stack direction={{ xs: 'column', sm: "row" }} justifyContent="space-between" alignItems={{ xs: '', sm: "center" }} gap={{ xs: 2, sm: 0 }} >
          <Box sx={{
            padding: '0 16px', position: 'relative', "&::before": {
              position: 'absolute', content: '""', top: 0, left: 0, bottom: 0, width: '6px', height: '100%', background: 'var(--red)', borderRadius: '0px 50px 50px 0px'
            }
          }}>
            <Typography sx={{ fontSize: { xs: '14px', sm: '18px', md: '22px', lg: '24px' }, fontWeight: 600, color: '#000' }}>
              {campaignStage > 6 ? "Campaign Preview" : formData?.id ? "Update Campaign" : "Create Campaign"}
            </Typography>
            <Typography sx={{ fontSize: { xs: '12px', md: '14px', lg: '16px' }, fontWeight: 600, color: '#AAA' }}>A name and description help people understand what your community is all about.</Typography>
          </Box>
          {campaignStage > 6 && <Button onClick={() => {
            setOpen(false);
            navigate(`/campaign/partial/details/${formData.id}`);
          }}
            sx={{ width: { sm: '50%', md: 'fit-content' }, background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '0', borderRadius: '10px', margin: '0px' }}><Typography sx={{ color: 'white', margin: '2px', borderRadius: '8px', padding: { xs: '8px 12px', md: '10px 18px', lg: '12px 24px' }, width: '100%', height: '100%', background: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, fontSize: { xs: '12px', md: '14px', lg: '16px' }, "&:hover": { background: 'transparent', color: 'white', } }}>Publish Campaign &nbsp;<img src={rocketWhite} alt="rocketWhite" />
            </Typography></Button>}
        </Stack>
      </Box>
    </>
  )
}
const Footer = ({ setCampaignStage, campaignStage, values, validate, dispatch, formData, navigate, handleAddInfluncersToCampaignsFromCurrentList, setOpen, isInfluncersDeletedFromCampaign }) => {
  const preparePayloadForStage = (stage, values, formData) => {
    switch (stage) {
      case 2: {
        const shipmentDetails = values?.shipmentDetails?.length > 0 ? 1 : 0;
        const isAffiliate = values?.trackingType === "appsFlyer" || values?.trackingType === "link";
        const deliverables = {
          name: values?.name || "Draft",
          shipmentDetails: shipmentDetails,
          deliverables: JSON.stringify([
            {
              plateform: values?.platform,
              deliverables: values?.selectedDeliverables?.filter((v) => v && v.qty > 0),
              post: values?.post,
            },
          ]),
        };
        const deliverablesCompleted =
          values?.platform !== "" &&
            values?.selectedDeliverables?.some((v) => v?.post && v?.qty) ? 1 : 0;
        if (isAffiliate) {
          let affliatePostdata = {
            name: values.name || "Draft",
            trackingType: values.trackingType,
          };
          let affilateData = 0;
          if (values.trackingType === "appsFlyer") {
            affliatePostdata = {
              ...affliatePostdata,
              appsFlyerId: values.appsFlyerId,
            };
            affilateData = values.appsFlyerId !== "" ? [values.appsFlyerId] : [];
          } else {
            affliatePostdata = {
              ...affliatePostdata,
              productLink: values.productLink,
              eventType: values.eventType,
            };
            affilateData = [values.productLink, values.eventType].filter((v) => v);
          }
          dispatch(
            updateCampaign({
              affliateSection: affilateData.length > 0 ? 1 : 0,
              formData: { ...formData, ...affliatePostdata },
            })
          );
          dispatch(addNewCampaign(affliatePostdata, navigate));
          return;
        }
        return {
          updateData: {
            deliverablesSection: deliverablesCompleted,
            formData: { ...formData, ...values, shipmentDetails },
          },
          payload: deliverables,
        }
      }
      case 4: {
        let filters = {
          gender: values?.gender,
          location: values?.creatorLocation,
          influencerType: values?.influncerType?.map((v) => v?.split(" ")[0]) || [],
          categories: values?.selectedCategories,
        };
        if (values?.gender === "Any") {
          delete filters?.gender;
        }
        let creator = {
          campaignApplyingPreferences: values?.campaignApplyingPreferences?.length > 0 ? 1 : 0,
          creator: JSON.stringify({
            gender: values?.gender,
            influncerType: values?.influncerType || [],
            selectedCategories: values?.selectedCategories,
            creatorLocation: values?.creatorLocation,
            campaignApplyingPreferences: values?.campaignApplyingPreferences?.length > 0
          }),
        };
        return {
          updateData: {
            formData: { ...formData, ...values },
            advanceFilter: filters,
            filters: { source: "campaign" }
          },
          payload: creator
        };
      }
      case 5: {
        let details = {
          name: values?.name,
          brandId: values?.brandId,
          products: values?.products ? JSON.stringify(values?.products) : JSON.stringify([]),
          startDate: values?.startDate,
          endDate: values?.endDate,
          bannerImage: values?.bannerImage || '',
          brief: values?.brief,
          productShipmentDate: values?.productShipmentDate || "",
          conceptScriptDate: values?.conceptScriptDate,
          contentSubmissionDate: values?.contentSubmissionDate,
          contentPublishDate: values?.contentPublishDate,
          budget: values?.budget,
          budgetPerInfluencer: values?.budgetPerInfluencer,
          noOfCreators: values?.noOfCreators,
          costPer: values?.costPer || "",
          costPerPrice: getCostPrice(values?.costPer, values) || "",
          kpiPerCreator: values?.kpiPerCreator ? 1 : 0,
          applyBydate: values?.applyBydate ? formatDate(values?.applyBydate) : "",
          eventProgramPrice: values?.eventProgramPrice || "",
          linkApproval: values?.linkApproval || 0,
          advancePayment: values?.advancePayment || 0,
          scriptApproval: values?.scriptApproval || 0,
          contentApproval: values?.contentApproval || 0,
        };
        let detailsCompleted = getDetailsValuesChecked(values) ? 1 : 0;
        return {
          updateData: {
            detailsSection: detailsCompleted,
            formData: { ...formData, ...values }
          },
          payload: details
        };
      }
      case 6: {
        let addtitonals = {
          name: values?.name || "Draft",
          accountMentions: values?.accountMentions || "",
          campaignHashtag: values?.campaignHashtag || "",
          referenceContentUrl: values?.referenceContentUrl || "",
          referenceContent: values?.referenceContent || "",
          contactDetails: values?.contactDetails || ""
        };
        let additionalCompleted = values?.contactDetails ? 1 : 0;
        return {
          updateData: {
            addtionalSection: additionalCompleted,
            formData: { ...formData, ...values }
          },
          payload: addtitonals
        };
      }
      default:
        return null;
    }
  };
  return (
    <>
      <Stack direction="row" justifyContent="flex-end" gap={2} sx={{ background: 'white', height: '7%', position: 'sticky', bottom: 0, left: 0, right: 0, overflow: 'hidden', borderTop: '2px solid #F0F0F0', paddingY: '10px', marginTop: '6px' }}>
        <Button disabled={campaignStage <= 1} onClick={() => setCampaignStage(prev => prev - 1)} sx={{ height: '44px', width: '100px', padding: '14px 16px', borderRadius: '8px', border: '1px solid #726C6C', background: 'white', color: '#726C6C' }}><Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Back</Typography></Button>
        {<Button disabled={!validate(campaignStage)} onClick={() => {
          if (campaignStage > 6) {
            setOpen(false);
            navigate(`/campaign/partial/details/${formData.id}`);
            return;
          }
          if (campaignStage === 3 && formData?.campaignId && !isInfluncersDeletedFromCampaign) {
            handleAddInfluncersToCampaignsFromCurrentList(formData?.campaignId, false)
          }
          const result = preparePayloadForStage(campaignStage, values, formData);
          if (result) {
            const { updateData, payload } = result;
            dispatch(updateCampaign(updateData));
            if (campaignStage > 1) {
              dispatch(addNewCampaign(payload, () => { }));
            }
          }
          setCampaignStage(prev => prev + 1);
        }} sx={{ width: '171px', height: '44px', borderRadius: '8px', color: 'white', background: !validate(campaignStage) ? "#B5B3B3" : 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)' }}><Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'white' }}>{campaignStage > 6 ? "Publish Campaign" : "Next"}</Typography></Button>}
      </Stack>
    </>
  )
}
const ProgressBar = ({ setCampaignStage, campaignStage, validate, type }) => {
  const ProgressList = [{ name: type === 'affiliate' ? 'Tracking' : 'Platform', value: 2 }, { name: 'Preference', value: 3 }, { name: 'Details', value: 4 }, { name: 'Date & Budget', value: 5 }, { name: 'Additional', value: 6 }]
  return (
    <Stack direction="row" sx={{ border: '0px solid purple', height: '7%' }}>
      {ProgressList.map((i) => (
        <Box sx={{ background: campaignStage === i.value ? 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)' : "#F0F0F0", height: '100%', width: '25%', paddingBottom: `${campaignStage === i.value ? '2px' : '2px'}` }}>
          <Stack onClick={() => {
            if (!validate(campaignStage) && i.value > campaignStage) {
              return;
            }
            setCampaignStage(i.value)
          }} direction="row" gap={1} sx={{ cursor: 'pointer', height: '100%', width: '100%', background: 'white', }} justifyContent="center" alignItems="center">
            {campaignStage > i.value ? <Box sx={{ background: 'linear-gradient(125deg,rgba(255, 204, 112, 0.5) 0%, rgba(200, 80, 192, 0.5) 50%, rgba(65, 88, 208, 0.5) 100%)', height: '32px', width: '32px', textAlign: 'center', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><img src={stepsCheckModalIcon} alt="rightCircle" style={{ background: 'transparent', borderRadius: '50%', height: '22px', width: '22px' }} /></Box> : <Typography sx={{ fontSize: '14px', fontWeight: 400, background: `${campaignStage === i.value ? 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)' : '#F0F0F0'}`, borderRadius: '50%', color: `${campaignStage === i.value ? 'white' : '#726C6C'}`, height: '30px', width: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>{i.value - 1}</Typography>}
            <Typography sx={{ fontSize: '14px', fontWeight: 400, color: 'black' }}>{i.name}</Typography></Stack>
        </Box>
      ))}
    </Stack>
  )
}
const SectionOne = ({ values, setFieldValue }) => {
  return (
    <>
      <Stack direction="row" flexWrap="wrap" justifyContent="flex-start" gap={4}>
        {
          CAMPAIGN_TYPES_WITH_DETAILS?.map((i) => (
            <Box onClick={() => {
              setFieldValue("type", i.type);
              setFieldValue("mode", "add");
              setFieldValue("demand", "");
            }} sx={{ cursor: 'pointer', width: '400px', height: '175px', padding: '20px', borderRadius: '12px', boxSizing: 'border-box', border: `2px solid ${(values?.type === i.type || (i.type === 'performance' && (values.type === 'performance' || values.type === 'affiliate'))) ? 'var(--color-blue)' : '#EEE'}` }}>
              <Stack direction="row" justifyContent="space-between" alignItems={"center"}>
                <img src={i.icon} alt={i.icon} style={{ height: '60px', width: '60px' }} />
                {(values?.type === i.type || (i.type === 'performance' && (values.type === 'performance' || values.type === 'affiliate'))) && <img src={rightCircle} alt="rightCircle" style={{ height: '24px', width: '24px' }} />}
              </Stack>
              <Box sx={{ paddingTop: '15px' }}>
                <Typography sx={{ fontSize: '16px', fontWeight: 600, color: 'black' }}>{i.heading}</Typography>
                <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#AAAAAA', paddingTop: '5px' }}>{i.subheading}</Typography>
              </Box>
            </Box>
          ))
        }
      </Stack>
      <Typography sx={{ fontSize: '22px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important', marginY: '20px' }}>What do you want to achieve from this campaign?</Typography>
      <Stack direction="row" flexWrap="wrap" justifyContent="flex-start" gap={4}>
        {
          ((values?.type === 'performance' || values.type === 'affiliate') ? PERFORMANCE_CAMPAIGNS_SUB_TYPES : CAMPAIGNS_SUB_TYPES)?.map((i) => (
            <Box onClick={() => {
              setFieldValue("demand", i.name);
              if (values?.type === 'performance' || values.type === 'affiliate') {
                setFieldValue("type", i.type)
              }
            }}
              sx={{ cursor: 'pointer', width: '140px', height: '130px', textAlign: 'center', borderRadius: '16px', border: `2px solid ${values.demand === i.name ? 'var(--color-blue)' : '#EEE'}`, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '10px', }}>
              <img src={i.icon} alt={i.icon} style={{ width: '52px', height: '52px' }} />
              <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#000000', marginTop: '10px' }}>{i.name}</Typography>
            </Box>
          ))
        }
        {values?.type === CAMPAIGN_TYPES.AFFILIATE && <Box
          sx={{ width: 'fit-content', height: '136px', textAlign: 'center', borderRadius: '16px', border: '2px solid #EEE', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
          <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#000000', marginY: '10px' }}>Not Connected Shopify/Appsflyer Account Yet?</Typography>
          <Stack onClick={() => {
            window.open("https://df7towsrrwicd.cloudfront.net/shopify-doc/ConnectYourShopifyAccountwithInflyxAccount.pdf", "_blank")
          }}
            variant="outlined"
            sx={{
              cursor: 'pointer',
              backgroundColor: '#fff',
              textTransform: 'none',
              width: '200px',
              borderRadius: 2,
              border: '0px solid #D3D3D3',
              display: 'flex',
              alignItems: 'center',
              padding: '10px ',
              gap: 1
            }}>
            <img src={shopifyIcon} alt="Shopify Logo" style={{ height: 24, marginRight: '8px' }} />
            <Typography gutterBottom>Connect with Shopify</Typography>
          </Stack>
        </Box>}
      </Stack>
    </>
  )
}
const SectionTwo = ({ errors, values, setFieldValue, touched, setFieldTouched, handleChange, handleBlur }) => {
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const { shopifyEvents } = useSelector((state) => state.commonSlice);
  const POST_TYPE = [{ name: 'post', title: 'This is a Collab Post', value: 'collabPost' }, { name: 'post', title: 'Access to boost this post', value: 'bostPost' }, { name: 'shipmentDetails', title: 'Product shipment details needed.', value: 'shipmentDetails' }]
  const UPDATED_PLATFORM_IMGS_LIST = {
    ...PLATFORMS_IMGS_LIST,
  }
  return (
    <>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color: 'black', paddingY: '24px', borderBottom: '0px solid #F0F0F0' }}>{values.type === "affiliate" ? "Select Tracking App" : "Select Platform & Audience--"}</Typography>
      {values.type === "affiliate" ? <>
        <Stack direction="row" justifyContent="flex-start" alignContent="center" gap={2} my={2}>
          <Stack direction="row" justifyContent="flex-start" alignContent="center" gap={2} >
            <Checkbox checked={values.trackingType === 'shopify'} onChange={(e) => {
              e.preventDefault();
              if (e.target.checked) {
                handleChange({
                  target: {
                    name: "trackingType",
                    value: "shopify"
                  }
                })
              }
              else {
                handleChange({
                  target: {
                    name: "trackingType",
                    value: ""
                  }
                })
              }
            }} />
            <Box sx={{ height: '50px', width: '150px', border: '1px solid #F0F0F0', padding: '6px 12px', borderRadius: '8px' }}>
              <img src="/shopify.png" alt="shopify.png" style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="flex-start" sx={{ display: 'none' }} alignContent="center" gap={2}>
            <Checkbox checked={values.trackingType === 'appsFlyer'} onChange={(e) => {
              e.preventDefault();
              if (e.target.checked) {
                handleChange({
                  target: {
                    name: "trackingType",
                    value: "appsFlyer"
                  }
                })
              }
              else {
                handleChange({
                  target: {
                    name: "trackingType",
                    value: ""
                  }
                })
              }
            }} />
            <Box sx={{ height: '50px', width: '150px', border: '1px solid #F0F0F0', padding: '6px 12px', borderRadius: '8px' }}>
              <img src="/appsFlyer.png" style={{ height: '100%', width: '100%', objectFit: 'contain' }} alt="appsFlyer.png" />
            </Box>
          </Stack>
        </Stack>
        <Grid container item spacing={3} lg={12} md={12} sm={12}>
          {values.trackingType !== "appsFlyer" ? <>
            <Grid item xs={6} lg={6} md={6} sm={12}>
              <FormLabel required sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400, marginBottom: '5px' }}>Shopify Product Link</FormLabel>
              <NormalInput
                name={"productLink"}
                type={"text"}
                focused={false}
                isRequired={false}
                label={""}
                sizeval="medium"
                values={values.productLink}
                onChange={handleChange}
                onBlur={handleBlur}
                error={Boolean(touched.productLink) && errors.productLink}
                helperText={touched.productLink && errors.productLink}
              />
            </Grid>
            <Grid item xs={6} lg={6} md={6} sm={12}>
              <FormLabel required sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400, marginBottom: '5px' }}>Select Event</FormLabel>
              <Select
                value={values.eventType}
                name="eventType"
                onChange={handleChange}
                displayEmpty
                defaultValue={values.eventType}
                sx={{ width: '100%' }}
              >
                {shopifyEvents?.map((v) => <MenuItem key={v} value={v} >
                  {v}
                </MenuItem>)}
              </Select>
              {errors.eventType && touched.eventType && (
                <p className="error m-0" style={{ paddingTop: 8, paddingBottom: 8 }}>{`${errors?.eventType}`}</p>
              )}
            </Grid>
          </>
            : <>
              <Grid item xs={12} lg={6} md={6} sm={12}>
                <FormLabel required sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400 }}>AppsFlyer App ID</FormLabel>
                <Select
                  value={values.appsFlyerId}
                  name="appsFlyerId"
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={values.appsFlyerId}
                  sx={{ width: '100%' }}
                >
                  {shopifyEvents?.map((v) => <MenuItem key={v} value={v} >
                    {v}
                  </MenuItem>)}
                </Select>
                {errors.appsFlyerId && touched.appsFlyerId && (
                  <p className="error m-0" style={{ paddingTop: 8, paddingBottom: 8 }}>{`${errors?.appsFlyerId}`}</p>
                )}
              </Grid>
              <Grid item xs={12} lg={6} md={6} sm={12}></Grid>
            </>
          }
        </Grid>
      </> : <><Box sx={{ padding: '24px', border: '1px solid #F0F0F0', borderRadius: '10px' }}>
        <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#2B2829', paddingBottom: '20px', borderBottom: '0px solid #F0F0F0', textTransform: 'uppercase' }}>Select a platform for your campaign.</Typography>
        <Stack direction="row" justifyContent="flex-start" gap={6}>
          {Object.keys(UPDATED_PLATFORM_IMGS_LIST)?.map((platformName) => {
            const platformKey = platformName?.toLowerCase();
            return (<><Stack direction="row" gap={1} key={platformName} sx={{ position: 'relative', cursor: 'pointer', background: (values?.platform === platformKey) && (platformKey === 'youtube') ? '#EA333E' : (values?.platform === platformKey) && (platformKey === 'instagram') ? 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)' : "#CCCBCB", padding: '2px', borderRadius: '8px' }}>
              <Stack onClick={() => {
                setFieldValue("platform", platformKey);
                setFieldValue("selectedDeliverables", []);
                setFieldValue("deliverables", DELIVERABLES_DATA?.find((item) => item[platformKey])?.[platformKey] || []);
                setFieldTouched("platform", true);
              }} direction="row" alignItems="center" sx={{ background: 'white', borderRadius: '6px', padding: '16px', boxSizing: 'border-box', "&:hover": { border: '0px solid var(--color-blue)' } }}><img src={UPDATED_PLATFORM_IMGS_LIST[platformName]} alt={platformName} style={{ height: '24px', width: '24px' }} />&nbsp;&nbsp;<Typography sx={{ fontSize: '16px', fontWeight: 400, background: 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', backgroundClip: 'text', color: (values?.platform === platformKey) && (values?.platform === 'youtube') ? '#EA333E' : (values?.platform === platformKey) && (values?.platform === 'instagram') ? 'transparent' : '#726C6C' }}>{platformName}</Typography></Stack>
              {values?.platform === platformKey && <img src={values?.platform === 'instagram' ? instaCheckIcon : youtubeCheckIcon} alt="values?.platform" style={{ position: 'absolute', top: '5px', right: '5px', height: '14px', width: '14px' }} />}
            </Stack></>
            );
          })}
        </Stack>
      </Box>
        <Box sx={{ padding: '24px', border: '1px solid #F0F0F0', borderRadius: '10px', marginTop: '24px' }}>
          <Accordion defaultExpanded sx={{ padding: 0, margin: 0, boxShadow: 0, border: '0px solid red !important', width: '100% !important', height: 'fit-content !important' }}>
            <AccordionSummary expandIcon={<ExpandMore />} sx={{ padding: 0, minHeight: 'fit-content !important' }}>
              <Box>
                <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'black', borderBottom: '0px solid #F0F0F0', textTransform: 'uppercase' }}>number of content</Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: 400, color: '#726C6C', borderBottom: '0px solid #F0F0F0' }}>Please specify the number of Instagram posts you expect from each influencer.</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0 }}>
              {values?.deliverables?.length > 0 && <Stack direction="column" justifyContent="flex-start" gap={4} sx={{ marginBottom: '32px', border: '1px solid #F0F0F0', padding: '24px', borderRadius: '10px', width: 'fit-content' }}>
                {values?.deliverables?.map((element, i) => (
                  <>
                    <Stack direction="row" justifyContent="flex-start" gap={10}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 2, width: '100px', border: '0px solid red' }}><img style={{ height: '24px', width: '24px' }} src={element.name === 'Image' ? imageIcon : element.name === 'Video' ? playIcon : element.name === 'Stories' ? storyIcon : ''} alt={element.name} /> <Typography sx={{ fontSize: '14px', fontWeight: 400, color: 'black' }}>{element.name}</Typography></Box>
                      <Box>
                        <Select
                          sx={{
                            minWidth: "fit-content",
                            borderRadius: "8px",
                            background: "white",
                            position: "relative",
                            overflow: "hidden",
                            width: '130px', height: '40px',
                            "& .MuiSelect-select": {
                              padding: '0 0px 0 13px !important',
                              width: '130px'
                            },
                            padding: '0px',
                            outline: 0,
                          }}
                          open={openDropdownIndex === i}
                          onOpen={() => setOpenDropdownIndex(i)}
                          onClose={() => setOpenDropdownIndex(null)}
                          IconComponent={(props) => <CustomDropdownIcon {...props} open={openDropdownIndex === i} />}
                          value={values?.selectedDeliverables?.length > 0 ? values?.selectedDeliverables?.find((item) => item?.type === element?.name?.toLowerCase())?.post || "" : ""} onChange={(e) => {
                            const updatedSelectedDeliverables = [...values.selectedDeliverables];
                            const index = updatedSelectedDeliverables.findIndex((item) => item?.type?.toLowerCase() === element?.name?.toLowerCase());
                            if (index === -1) {
                              updatedSelectedDeliverables.push({
                                post: e.target.value,
                                type: element?.name?.toLowerCase(),
                                qty: 0
                              });
                            }
                            else {
                              updatedSelectedDeliverables[index] = {
                                ...updatedSelectedDeliverables[index],
                                post: e.target.value,
                                type: element?.name?.toLowerCase(),
                                qty: 0,
                              };
                            }
                            setFieldValue("selectedDeliverables", updatedSelectedDeliverables);
                          }}
                          displayEmpty
                        >  <MenuItem value="" disabled>Select</MenuItem>
                          {element?.dropDownvalue?.map(
                            (v) => {
                              return (
                                <MenuItem value={v} key={v}>
                                  {v}
                                </MenuItem>
                              );
                            }
                          )}</Select></Box>
                      <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={2}><Button disableRipple disabled={values?.selectedDeliverables?.find((item) => item?.type?.toLowerCase() === element?.name?.toLowerCase())?.qty <= 0} sx={{ padding: 0, background: 'transparent', height: '100%', width: '100%', minWidth: '28px', borderRadius: '50%', "&:hover": { background: 'transparent' } }} onClick={() => {
                        const updatedSelectedDeliverables = [...values.selectedDeliverables];
                        const index = updatedSelectedDeliverables?.findIndex((item) => item?.type?.toLowerCase() === element?.name?.toLowerCase());
                        if (index > -1) {
                          updatedSelectedDeliverables[index] = {
                            ...updatedSelectedDeliverables[index],
                            qty: (updatedSelectedDeliverables[index]?.qty || 0) - 1
                          };
                        }
                        setFieldValue("selectedDeliverables", updatedSelectedDeliverables);
                      }}>
                        <img src={minusIcon} style={{ width: '28px', height: '28px' }} alt='add' /></Button><Typography>{values?.selectedDeliverables?.find((item) => item?.type?.toLowerCase() === element?.name?.toLowerCase())?.qty || 0}</Typography><Button disableRipple sx={{ padding: 0, background: 'transparent', height: '100%', width: '100%', minWidth: '28px', borderRadius: '50%', "&:hover": { background: 'transparent' } }} onClick={() => {
                          const updatedSelectedDeliverables = [...values.selectedDeliverables];
                          const index = updatedSelectedDeliverables.findIndex((item) => item?.type?.toLowerCase() === element?.name?.toLowerCase());
                          if (index > -1) {
                            updatedSelectedDeliverables[index] = {
                              ...updatedSelectedDeliverables[index],
                              qty: (updatedSelectedDeliverables[index]?.qty || 0) + 1
                            };
                          }
                          setFieldValue("selectedDeliverables", updatedSelectedDeliverables);
                        }}><img src={AddIcon} style={{ width: '28px', height: '28px' }} alt='add' /></Button></Stack>
                    </Stack>
                  </>
                ))}
                {touched["platform"] && errors.selectedDeliverables && (
                  <p className="error m-0">
                    {`${errors?.selectedDeliverables}`}
                  </p>
                )}
              </Stack>}
              <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={4}>
                {POST_TYPE?.map((item) => (
                  <Stack direction="row" onBlur={() => setFieldTouched(`${item.name}`, true)} name={item.name} alignItems="center" justifyContent="flex-start" gap={2}><Checkbox onClick={(e) => {
                    if (e.target.checked) {
                      setFieldValue(`${item.name}`, [...(values?.[item?.name] || []), item.value]);
                    }
                    else {
                      setFieldValue(`${item.name}`, (values[item.name] || [])?.filter((i) => i !== item.value));
                    }
                    setFieldTouched(`${item.name}`, true);
                  }} checked={Array.isArray(values?.[item.name]) && values?.[item.name]?.includes(item.value)} />
                    <Typography sx={{ fontSize: '14px', fontWeight: 400, color: 'black' }}>{item.title}</Typography></Stack>
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Box></>}
    </>
  )
}
const SectionThree = ({ handleChange, errors, values, setFieldValue, touched }) => {
  const { niches } = useSelector((state) => state.commonSlice);
  const [categoryNiches, setCategoryNiches] = useState(niches.slice(0, 24) || []);
  const handleManageFieldOption = () => {
    let updatedList;
    if (categoryNiches.length > 24) {
      updatedList = niches.slice(0, 24);
    } else {
      updatedList = niches;
    }
    setCategoryNiches(updatedList);
  }
  return (
    <>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color: 'black', paddingY: '24px', borderBottom: '0px solid #F0F0F0' }}>Applying Preference--</Typography>
      <Box sx={{ borderRadius: '10px', padding: '24px', border: '1px solid #F0F0F0' }}>
        <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#2B2829', paddingBottom: '20px', borderBottom: '0px solid #F0F0F0', textTransform: 'uppercase' }}>Campaign Applying preference</Typography>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={2}><Checkbox checked={values?.campaignApplyingPreferences?.length > 0} onChange={(e) => {
          if (e.target.checked) {
            setFieldValue("campaignApplyingPreferences", ['campaignApplyingPreferences'])
          } else {
            setFieldValue("campaignApplyingPreferences", [])
          }
        }} /><Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400 }}>Apply By Everyone</Typography></Stack>
      </Box>
      <Box sx={{ padding: '24px', border: '1px solid #F0F0F0', borderRadius: '10px', marginTop: '24px' }}>
        <Accordion defaultExpanded sx={{ padding: 0, margin: 0, boxShadow: 0, border: '0px solid red !important', width: '100% !important', height: 'fit-content !important' }}>
          <AccordionSummary expandIcon={<ExpandMore />} sx={{ padding: 0, minHeight: 'fit-content !important' }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'black', borderBottom: '0px solid #F0F0F0', textTransform: 'uppercase' }}>Creator Preference</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 500, paddingBottom: '16px', }}>Creator Gender</Typography>
            <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={2}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="gender"
                value={values?.gender}
                onChange={handleChange}>
                {GENDER.filter((i) => i !== 'Any').map((v, i) => {
                  return <FormControlLabel key={i} value={v} control={<Radio sx={{ padding: 0, }} />} label={v} />
                })}
              </RadioGroup>
            </Stack>
            <Stack direction="row" justifyContent="space-between" gap={4} alignItems="center" sx={{ width: '100%' }}>
              <Box sx={{ width: '100%' }}>
                <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 500, paddingY: '16px', }}>Creator Location <span style={{ color: 'var(--red)' }}>*</span></Typography>
                <AutoSuggestion
                  limitTags={2}
                  multiple={true}
                  disableClearable={true}
                  values={values?.creatorLocation}
                  className="auto-chips-cover"
                  label={""}
                  onChange={(_e, newValue) => {
                    handleChange({
                      target: { name: "creatorLocation", value: newValue },
                    });
                  }}
                  placeholder="Ex. Mumbai, Delhi"
                  defaultValue={values?.creatorLocation || []}
                  id={`users-${values?.creatorLocation?.length}`}
                  onModalClose={() => { }}
                  size="small"
                  name="creatorLocation"
                  error={Boolean(touched.creatorLocation) && errors.creatorLocation}
                  helperText={touched.creatorLocation && errors.creatorLocation}
                  options={citiesInIndia}
                  isOptionEqualToValue={(option, value) => {
                    if (
                      value === "" ||
                      option === "" ||
                      value === option
                    )
                      return option;
                  }}
                  getOptionLabel={(option) =>
                    option || "no_option_found"
                  }
                  renderOption={(props, option) => {
                    return (
                      <Box
                        component="li"
                        sx={{
                          "& > img": { mr: 2, flexShrink: 0 },
                          fontFamily: "var(--family1)", fontSize: '12px'
                        }}
                        {...props}>
                        {option}
                      </Box>
                    );
                  }}
                />
              </Box>
              <Box sx={{ width: '100%' }}>
                <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 500, paddingY: '16px', }}>Creator Type <span style={{ color: 'var(--red)' }}>*</span></Typography>
                <AutoSuggestion
                  limitTags={2}
                  multiple={true}
                  disableClearable={true}
                  values={
                    FOLLOWERS_ARRAY?.filter((item) => Array.isArray(values?.influncerType) && values?.influncerType?.includes(item.value)) || []
                  }
                  className="auto-chips-cover"
                  label={""}
                  onChange={(_e, newValue) => {
                    handleChange({
                      target: { name: "influncerType", value: newValue?.map((i) => i.value) },
                    });
                  }}
                  placeholder="Ex. 2K-10K (Nano)"
                  defaultValue={FOLLOWERS_ARRAY.filter((item) => values?.influncerType?.includes(item.value)) || []}
                  id={`users-${values?.influncerType?.length}`}
                  onModalClose={() => { }}
                  size="small"
                  name="influncerType"
                  error={Boolean(touched.influncerType) && errors.influncerType}
                  helperText={touched.influncerType && errors.influncerType}
                  options={FOLLOWERS_ARRAY}
                  isOptionEqualToValue={(option, value) => {
                    return option?.value === value;
                  }}
                  getOptionLabel={(option) =>
                    option.label || "no_option_found"
                  }
                  renderOption={(props, option) => {
                    return (
                      <Box
                        component="li"
                        sx={{
                          "& > img": { mr: 2, flexShrink: 0 },
                          fontFamily: "var(--family1)", fontSize: '12px'
                        }}
                        {...props}
                      >
                        {option.label}
                      </Box>
                    );
                  }}
                />
              </Box>
            </Stack>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Box sx={{ borderRadius: '10px', padding: '24px', border: '1px solid #F0F0F0', marginTop: '24px' }}>
        <Accordion defaultExpanded sx={{ padding: 0, margin: 0, boxShadow: 0, border: '0px solid red !important', width: '100% !important', height: 'fit-content !important' }}>
          <AccordionSummary expandIcon={<ExpandMore />} sx={{ padding: 0, minHeight: 'fit-content !important' }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: 'black', borderBottom: '0px solid #F0F0F0', textTransform: 'uppercase' }}>Category</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <Stack direction="row" alignItems="center" >
              <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 500, paddingBottom: '16px', }}>Creator Category <span style={{ color: 'var(--red)' }}>*</span></Typography> &nbsp;<Box style={{ fontSize: '10px', fontWeight: 700, color: 'white', background: 'var(--color-blue)', borderRadius: '50%', padding: '0px', height: '20px', width: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '16px', }}>{values?.selectedCategories?.length || 0}</Box>
            </Stack>
            <List sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1, flexDirection: 'row', flexWrap: 'wrap' }}>
              {categoryNiches?.map((niche, index) => (
                <><ListItem onClick={(e) => {
                  e.preventDefault();
                  let updatedCategory = values?.selectedCategories?.length > 0 ? [...values?.selectedCategories] : [];
                  if (updatedCategory.includes(niche)) {
                    updatedCategory = updatedCategory.filter((item) => item !== niche);
                  }
                  else {
                    updatedCategory?.push(niche);
                  }
                  handleChange({
                    target: {
                      name: 'selectedCategories',
                      value: updatedCategory
                    }
                  });
                }} sx={{ "&:hover": { background: 'black', border: '1px solid black', "& p": { color: 'white' } }, cursor: 'pointer', width: 'fit-content', padding: '2px 8px', borderRadius: '50px', border: `1px solid ${(values?.selectedCategories || []).includes(niche) ? "black" : "#CCCBCB"}`, background: `${(values?.selectedCategories || []).includes(niche) ? "black" : "white"}` }} key={niche} value={niche}><img alt={niche} src={`/influncersCategoryIcons/category_icon_${index + 1}.svg`} style={{ height: '20px', width: '20px' }} />&nbsp;<Typography sx={{ fontSize: '12px', fontWeight: 500, color: `${(values?.selectedCategories || []).includes(niche) ? "white" : "#726C6C"}` }}>{niche} {(values?.selectedCategories || []).includes(niche) && <img src={XWhite} alt="XWhite" style={{ height: '16px', width: '16px' }} />}</Typography></ListItem>
                  {niches.length > 20 && index + 1 === categoryNiches.length && (<ListItem sx={{ width: 'fit-content' }}>
                    <Button disableRipple sx={{ height: '32px', borderRadius: '62px', border: '0px solid #0077FF', textDecoration: 'underline', fontSize: '12px !important', fontWeight: '500 !important', fontFamily: 'var(--family1)', "&:hover": { border: 0, textDecoration: 'underline', background: 'none' } }} onClick={() => handleManageFieldOption(index)}>{categoryNiches.length === 20 ? "View More" : "View Less"}</Button>
                  </ListItem>)}
                </>
              ))}
            </List>
          </AccordionDetails></Accordion>
      </Box>
    </>
  )
}
const SectionFour = ({ formData, dispatch, handleChange, errors, values, setFieldValue, touched, handleBlur }) => {
  const { brandsDropdown } = useSelector((state) => state.brandSlice);
  const {
    productDropdown,
  } = useSelector((state) => state.campaignSlice);
  const [preview, setPreview] = useState(values?.bannerImage || null);
  const [bannerImageError, setBannerImageError] = useState("")
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    handleFile(file);
  };
  const handleFile = async (file) => {
    if (!file) return;
    if (!CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES.includes(file.type)) {
      setBannerImageError('Invalid file format. Please upload a JPEG or PNG image.')
      return;
    }
    setBannerImageError("")
    const img = new Image();
    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target.result;
      img.onload = async () => {
        const isAllowedDimension = CAMPAIGN_BANNER_IMAGE_ALLOWED_DIMESHION.some(
          (dim) => dim.width === img.width && dim.height === img.height
        );
        if (!isAllowedDimension) {
          setBannerImageError(`Invalid image dimensions. Allowed sizes are 1920x1080, 1280x720, or 1024x576. Your image is ${img.width}x${img.height}.`)
          return;
        }
        setBannerImageError("");
        const base64 = e.target.result;
        setPreview(base64);
        handleChange({
          target: {
            name: "bannerImage",
            value: file,
          }
        })
        handleChange({
          target: {
            name: "bannerImageBase64",
            value: JSON.stringify({
              name: file.name,
              size: file.size,
              type: file.type,
              lastModified: file.lastModified,
              base64,
            }),
          }
        })
      };
    };
    reader.readAsDataURL(file);
  };
  const handleDeleteBannerImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleChange({
      target: {
        name: "bannerImage",
        value: "",
      }
    })
    handleChange({
      target: {
        name: "bannerImageBase64",
        value: null,
      }
    })
    setPreview(null);
  }
  useEffect(() => {
    dispatch(getAllBrandForDropDown());
  }, [])
  useEffect(() => {
    dispatch(
      updateCampaign({
        productDropdown: brandsDropdown?.find(
          (v) => v.id === values.brandId
        )?.product,
      })
    );
  }, [values, brandsDropdown]);
  const handleStartDateChange = (e) => {
    const value = e.target.value;
    setFieldValue("startDate", value);
    handleClearOtherDates();
  };
  const handleEndDateChange = (e) => {
    const value = e.target.value;
    setFieldValue("endDate", value);
    handleClearOtherDates();
  };
  const handleClearOtherDates = () => {
    setFieldValue("applyBydate", "");
    setFieldValue("conceptScriptDate", "");
    setFieldValue("contentSubmissionDate", "");
    setFieldValue("contentPublishDate", "");
  }
  return (
    <>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color: 'black', paddingY: '24px', borderBottom: '0px solid #F0F0F0' }}>Campaign Details---</Typography>
      <Box sx={{ padding: '24px', border: '1px solid #F0F0F0', borderRadius: '10px' }}>
        <Accordion defaultExpanded sx={{ padding: 0, margin: 0, boxShadow: 0, border: '0px solid red !important', width: '100% !important', height: 'fit-content !important' }}>
          <AccordionSummary expandIcon={<ExpandMore />} sx={{ padding: 0, minHeight: 'fit-content !important' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', borderBottom: '0px solid #F0F0F0', textTransform: 'uppercase' }}>Campaign Details</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <Grid container spacing={3} lg={12} md={12} sm={12}>
              <Grid item xs={6} lg={6} md={6} sm={6}>
                <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>Campaign Name</FormLabel>
                <NormalInput
                  name={"name"}
                  type={"text"}
                  focused={false}
                  isRequired={false}
                  label={""}
                  sizeval="medium"
                  values={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(touched.name) && errors.name}
                  helperText={touched.name && errors.name}
                />
              </Grid>
              <Grid item xs={6} lg={6} md={6} sm={6}>
                <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>Brand Name</FormLabel>
                <BasicSelect
                  required={false}
                  name={"brandId"}
                  label={""}
                  values={values.brandId}
                  disabled={formData?.status === LIVE}
                  handleChange={(e) => {
                    handleChange(e);
                    handleChange({
                      target: {
                        name: "productName",
                        value: "",
                      },
                    });
                    handleChange({
                      target: {
                        name: "products",
                        value: [{ name: "", link: "" }],
                      },
                    });
                    dispatch(
                      updateCampaign({
                        productDropdown: brandsDropdown?.find(
                          (item) => item.id === e.target.value
                        )?.product,
                      })
                    );
                    setFieldValue(
                      "brandName",
                      brandsDropdown.find(
                        (item) => item.id === e.target.value
                      )?.brandName
                    );
                  }}
                  options={brandsDropdown?.map((item) => {
                    return (
                      <MenuItem value={item.id} key={item.id}>
                        {item.brandName}
                      </MenuItem>
                    );
                  })}
                />
                {errors.brandId && touched.brandId && (
                  <p className="error m-0">
                    {`${errors?.brandId}`}
                  </p>
                )}
              </Grid>
              <FieldArray
                name={`products`}
                key={productDropdown?.length}
                render={(array) => (
                  <>
                    {values?.products?.map((post, index) => (
                      <>
                        <Grid item xs={12} lg={6} md={6} sm={6}>
                          <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                            Product Name-{index + 1}
                          </FormLabel>
                          <BasicSelect
                            required={false}
                            name={`products.[${index}].name`}
                            label={""}
                            disabled={formData?.status === LIVE}
                            defaultValue={
                              values.products[index].name
                            }
                            values={values.products[index].name}
                            handleChange={handleChange}
                            options={productDropdown?.map(
                              (item, index) => {
                                return (
                                  <MenuItem
                                    value={item.name}
                                    key={index}
                                    disabled={values.products
                                      .map((v) => v.name)
                                      .includes(item.name)}>
                                    {item.name}
                                  </MenuItem>
                                );
                              }
                            )}
                          />
                          <Field
                            name={`products.[${index}].name`}
                            render={({ form }) => {
                              const error = getIn(
                                form.errors,
                                `products.[${index}].name`
                              );
                              const touch = getIn(
                                form.touched,
                                `products.[${index}].name`
                              );
                              return touch && error ? (
                                <p className="error">{error}</p>
                              ) : null;
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          lg={productDropdown?.length > 1 ? 5.5 : 6}
                          md={productDropdown?.length > 1 ? 5.5 : 6}
                          sm={productDropdown?.length > 1 ? 5.5 : 6}>
                          <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                            Product link-{index + 1}
                          </FormLabel>
                          <NormalInput
                            name={`products.[${index}].link`}
                            type={"text"}
                            focused={false}
                            label={""}
                            sizeval="medium"
                            values={values.products[index].link}
                            isRequired={false}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <Field
                            class="error"
                            name={`products.[${index}].link`}
                            render={({ form }) => {
                              const error = getIn(
                                form.errors,
                                `products.[${index}].link`
                              );
                              const touch = getIn(
                                form.touched,
                                `products.[${index}].link`
                              );
                              return touch && error ? (
                                <p className="error">{error}</p>
                              ) : null;
                            }}
                          />
                        </Grid>
                        {productDropdown?.length > 1 && (
                          <Grid
                            item
                            xs={12}
                            mt={3}
                            lg={0.5}
                            md={0.5}
                            sm={0.5}>
                            {productDropdown?.length === 1 ||
                              (index === 0 &&
                                productDropdown?.length !==
                                values.products?.length) ? (
                              <img
                                src="/plus.png"
                                onClick={() => {
                                  if (!values.brandId) return;
                                  array.push({
                                    name: "",
                                    link: "",
                                  });
                                }}
                                alt="plus"
                                width={"25px"}
                              />
                            ) : (
                              <img
                                src="/minus.png"
                                onClick={(e) => {
                                  e.preventDefault();
                                  array.remove(index);
                                }}
                                alt="minus"
                                width={"25px"}
                              />
                            )}
                          </Grid>
                        )}
                      </>
                    ))}
                  </>
                )}
              />
              <Grid item xs={6} lg={6} md={6} sm={6}>
                <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>Start Date</FormLabel>
                <NormalInput
                  name={"startDate"}
                  type={"date"}
                  focused={false}
                  isDisabled={formData?.status === LIVE}
                  isRequired={false}
                  label={""}
                  min={
                    formData.mode === "edit" && formData?.status !== DRAFT
                      ? values?.startDate || formatDate(new Date())
                      : formatDate(new Date(), "dd/mm/yyyy")
                  }
                  sizeval="medium"
                  defaultValue={values?.startDate}
                  values={values?.startDate}
                  onChange={handleStartDateChange}
                  onBlur={handleBlur}
                  error={
                    Boolean(touched.startDate) &&
                    errors.startDate
                  }
                  helperText={
                    touched.startDate && errors.startDate
                  }
                />
              </Grid>
              <Grid item xs={6} lg={6} md={6} sm={6}>
                {
                  ![CAMPAIGN_TYPES.AFFILIATE, CAMPAIGN_TYPES.PERFORMANCE].includes(values.type) &&
                  <><FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>End Date</FormLabel><NormalInput
                    name={"endDate"}
                    type={"date"}
                    focused={false}
                    isRequired={false}
                    label={""}
                    sizeval="medium"
                    isDisabled={!values.startDate}
                    min={values?.startDate}
                    values={values?.endDate}
                    onChange={handleEndDateChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.endDate) && errors.endDate}
                    helperText={touched.endDate && errors.endDate} /></>
                }
              </Grid>
              {
                [CAMPAIGN_TYPES.AFFILIATE, CAMPAIGN_TYPES.PERFORMANCE].includes(values.type) && <>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                    <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'black', borderBottom: '0px solid #F0F0F0', textTransform: 'uppercase' }}>
                      Do you want this campaign End Date and KPIs Per Creator?
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={6} md={6} sm={12}>
                    <Stack direction={"row"} gap={3} pt={3} >
                      <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                          <FormControlLabel
                            value={values.kpiPerCreator == 1}
                            control={<Switch color="primary" defaultChecked={Boolean(values.kpiPerCreator)} value={values.kpiPerCreator} name="kpiPerCreator" onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />}
                            label="End Date"
                            labelPlacement="start"
                          />
                        </FormGroup>
                      </FormControl>
                      <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px', pt: 1 }} gutterBottom>
                        Measure by KPIs per creator&nbsp;<Tooltip arrow title="This option will automatically close the campaign for the Influencer as and when they hit the per Influencer budget" placement="top"><InfoIcon fontSize='small' color="secondary" /></Tooltip>
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={6} lg={6} md={6} sm={6}>
                    <FormLabel required>{values.kpiPerCreator ? "Tracking Expiry date" : "End Date"}{values.kpiPerCreator && <Tooltip arrow title="Please select the date till you want to measure the selected KPIs" placement="top"><InfoIcon fontSize='small' color="secondary" /></Tooltip>}</FormLabel>
                    <NormalInput
                      name={"endDate"}
                      isDisabled={!values.startDate}
                      type={"date"}
                      focused={false}
                      isRequired={false}
                      label={""}
                      sizeval="medium"
                      min={values?.startDate}
                      values={values?.endDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        Boolean(touched.endDate) && errors.endDate
                      }
                      helperText={touched.endDate && errors.endDate}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                    <hr></hr>
                  </Grid>
                </>
              }
              <Grid item xs={6} lg={6} md={6} sm={6}>
                <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>Brand Banner</FormLabel>
                <Box
                  onDrop={handleDrop}
                  onDragOver={(e) => e.preventDefault()}
                  sx={{
                    border: '1px dashed #E5E5E5',
                    borderRadius: '16px',
                    padding: '16px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    background: '#FAFAFA',
                    position: 'relative',
                    width: '100%', height: '150px'
                  }}>
                  <input
                    type="file"
                    accept="image/*"
                    id="fileInput"
                    style={{ display: 'block', height: '100%', width: '100%', border: '2px solid red', opacity: 0 }}
                    onChange={handleFileChange}
                  />
                  <label htmlFor="fileInput" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, padding: '16px', cursor: 'pointer' }}>
                    {preview ? (
                      <Stack
                        direction="row" justifyContent="flex-start" gap={0} alignItems="center"
                        sx={{
                          width: '100%',
                          height: '100%',
                          borderRadius: 2,
                          border: '0px solid red'
                        }}>
                        <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={2} sx={{ height: '100px', width: '350px', background: '#F0F0F0', borderRadius: '10px', padding: '14px' }}>
                          <Box sx={{ height: '65px', width: '65px', position: 'relative' }}>
                            <img src={preview} alt="preview" style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '5px' }} />
                            <div style={{ position: 'absolute', top: 0, left: 0, background: 'rgba(0,0,0,0.5)', height: '100%', width: '100%', padding: '17px', borderRadius: '5px' }}>
                              <img src={imageIconWhite} alt="imageIconWhite" style={{ height: '24px', width: '24px' }} />
                            </div>
                          </Box>
                          <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400, minWidth: '200px', textAlign: 'left' }}>{JSON.parse(values?.bannerImageBase64 || "{}")?.name?.substring(0, 30) || "Banner Image"}</Typography>
                          <img src={check} alt="check" style={{ height: '24px', width: '24px' }} />
                        </Stack>
                        <Button sx={{ "&:hover": { background: 'transparent' } }} disableRipple onClick={handleDeleteBannerImage}><img src={deleteIconRed} alt="check" style={{ height: '24px', width: '24px' }} /></Button>
                      </Stack>
                    ) : (
                      <>
                        <img src={imageIcon} alt="" style={{ height: '32px', width: '32px' }} />
                        <Typography variant="body1" sx={{ mt: 0.7, fontSize: '12px', fontWeight: 600 }}>
                          <span style={{ color: 'var(--color-blue)', textDecoration: 'underline', }}>
                            Click to upload
                          </span>{' '}
                          or drag and drop
                        </Typography>
                        <Typography variant="caption" sx={{ mt: 0.7, display: 'block', color: '#A3A3A3', fontSize: '10px', fontWeight: 400, }}>
                          Supported dimensions (pixels) are 1920 x 1080,1280 x 720 and 1024 x 576. Image formats like JPEG and PNG
                        </Typography>
                        {bannerImageError && (<Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}>
                          {bannerImageError}
                        </Typography>)}
                      </>
                    )}
                  </label>
                </Box>
                <Typography width={"200px"}>
                </Typography>
                {errors.bannerImage && touched.bannerImage && (
                  <p className="error">
                    {`${errors?.bannerImage}`}
                  </p>
                )}
              </Grid>
              <Grid item xs={6} lg={6} md={6} sm={6} className='campaignModal'>
                <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>Campaign Brief</FormLabel>
                <Editor
                  value={values.brief}
                  onChange={(e) => {
                    handleChange({
                      target: {
                        name: "brief",
                        value: e.target.value,
                      },
                    });
                  }}>
                </Editor>
                {errors.brief && touched.brief && (
                  <p className="error m-0">
                    {`${errors?.brief}`}
                  </p>
                )}
              </Grid>
            </Grid>
          </AccordionDetails></Accordion>
      </Box>
    </>
  )
}
const SectionFive = ({ formData, dispatch, handleChange, errors, values, setFieldValue, touched, handleBlur, setCampaignStage }) => {
  return (
    <>
      <Schedular formData={formData} values={values} handleChange={handleChange} setCampaignStage={setCampaignStage} />
      <Box sx={{ padding: '24px', border: '1px solid #F0F0F0', borderRadius: '10px', marginTop: '24px' }}>
        <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#2B2829', textTransform: 'uppercase', paddingBottom: '24px' }}>Campaign budget <span style={{ color: 'var(--red)' }}>*</span></Typography>
        <Stack direction="row" justifyContent="space-between" gap={2} flexWrap="wrap">
          <Box sx={{ width: '49%' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#2B2829', paddingBottom: '5px' }}>What is your overall budget for this campaign?</Typography>
            <NumberInput
              name={"budget"}
              type={"number"}
              isRequired={false}
              focused={false}
              label={""}
              sizeval="medium"
              values={values.budget}
              placeholder={"Ex. 50000"}
              onChange={handleChange}
              onBlur={handleBlur}
              style={FORM_INPUTFIELD_STYLES}
              error={
                Boolean(touched.budget) && errors.budget
              }
              helperText={touched.budget && errors.budget}
            />
          </Box>
          <Box sx={{ width: '49%' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#2B2829', paddingBottom: '5px' }}>Budget per creator?</Typography>
            <NumberInput
              name={"budgetPerInfluencer"}
              type={"number"}
              isRequired={false}
              focused={false}
              label={""}
              sizeval="medium"
              style={FORM_INPUTFIELD_STYLES}
              values={values.budgetPerInfluencer}
              placeholder={"Ex. 50000"}
              onChange={handleChange}
              onBlur={handleBlur}
              error={
                Boolean(touched.budgetPerInfluencer) &&
                errors.budgetPerInfluencer
              }
              helperText={
                touched.budgetPerInfluencer &&
                errors.budgetPerInfluencer
              }
            />
          </Box>
          <Box sx={{ width: '49%' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#2B2829', paddingBottom: '5px' }}>No. of creator?</Typography>
            <NumberInput
              name={"noOfCreators"}
              type={"number"}
              isRequired={false}
              focused={false}
              label={""}
              sizeval="medium"
              style={FORM_INPUTFIELD_STYLES}
              values={values.noOfCreators}
              placeholder={"Ex. 50000"}
              onChange={handleChange}
              onBlur={handleBlur}
              error={
                Boolean(touched.noOfCreators) &&
                errors.noOfCreators
              }
              helperText={
                touched.noOfCreators && errors.noOfCreators
              }
            />
          </Box>
        </Stack>
      </Box>
      {values.type === CAMPAIGN_TYPES.PAID && (<Box sx={{ padding: '24px', marginTop: '24px', borderRadius: '10px', border: '1px solid #F0F0F0' }}>
        <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#2B2829', textTransform: 'uppercase' }}>Define milestone payment <Tooltip placement='top' title="You can choose what all milestones are to be included as part of your milestone payments by just entering values in the specific fields below. The field that are left blank won't become part of your campaign milestones."><img src={infoIcon} alt="infoicon" style={{ height: '16px', width: '16px' }} /></Tooltip></Typography>
        <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#726C6C', paddingBottom: '24px', }}>Select the stages you want to keep millstones</Typography>
        <Stack direction="column" gap={2} justifyContent="flex-start">
          <Stack alignItems="center" direction="row" justifyContent="space-start">
            <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#726C6C', width: '40%' }}>Advance Payment</Typography>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1} sx={{ width: '60%' }}>
              <NumberInput
                className="ttldiscount"
                name={"advancePayment"}
                isRequired={false}
                startAdornment={true}
                startAdornmentText="%"
                type={"number"}
                focused={false}
                label={("")}
                placeholder={""}
                sizeval="medium"
                values={values?.advancePayment}
                onChange={(e) => {
                  if (e.target.value <= 100) {
                    handleChange(e);
                  } else {
                    e.preventDefault();
                  }
                }}
                onBlur={handleBlur}
                onKeyDown={(e) => {
                  phonePreventText.includes(e.key) &&
                    e.preventDefault()
                }
                }
                error={
                  Boolean(touched.advancePayment) &&
                  errors.advancePayment
                }
                helperText={
                  touched.advancePayment &&
                  errors.advancePayment
                }
              />
              <Typography sx={{ fontSize: '10px', fontWeight: 400, color: '#726C6C' }}>(Usually brands pay 10% as standard practice)</Typography>
            </Stack>
          </Stack>
          <Stack alignItems="center" direction="row" justifyContent="flex-start">
            <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#726C6C', width: '40%' }}>Script Approval</Typography>
            <NumberInput
              className="ttldiscount"
              name={"scriptApproval"}
              isRequired={false}
              startAdornment={true}
              startAdornmentText="%"
              type={"number"}
              focused={false}
              label={("")}
              placeholder={""}
              sizeval="medium"
              values={values?.scriptApproval}
              onChange={(e) => {
                if (e.target.value <= 100) {
                  handleChange(e);
                } else {
                  e.preventDefault();
                }
              }}
              onBlur={handleBlur}
              onKeyDown={(e) => {
                phonePreventText.includes(e.key) &&
                  e.preventDefault()
              }
              }
              error={
                Boolean(touched.scriptApproval) &&
                errors.scriptApproval
              }
              helperText={
                touched.scriptApproval &&
                errors.scriptApproval
              }
            />
          </Stack>
          <Stack alignItems="center" direction="row" justifyContent="flex-start">
            <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#726C6C', width: '40%' }}>Content Approval</Typography>
            <NumberInput
              className="ttldiscount"
              name={"contentApproval"}
              isRequired={false}
              startAdornment={true}
              startAdornmentText="%"
              type={"number"}
              focused={false}
              onKeyDown={(e) => {
                phonePreventText.includes(e.key) &&
                  e.preventDefault()
              }
              }
              label={("")}
              placeholder={""}
              sizeval="medium"
              values={values?.contentApproval}
              onChange={(e) => {
                if (e.target.value <= 100) {
                  handleChange(e);
                } else {
                  e.preventDefault();
                }
              }}
              onBlur={handleBlur}
              error={
                Boolean(touched.contentApproval) &&
                errors.contentApproval
              }
              helperText={
                touched.contentApproval &&
                errors.contentApproval
              }
            />
          </Stack>
          <Stack alignItems="center" direction="row" justifyContent="flex-start">
            <Typography sx={{ fontWeight: 500, fontSize: '14px', color: '#726C6C', width: '40%' }}>Publish Link Approval</Typography>
            <NumberInput
              className="ttldiscount"
              name={"linkApproval"}
              isRequired={false}
              startAdornment={true}
              startAdornmentText="%"
              type={"number"}
              focused={false}
              onKeyDown={(e) => {
                phonePreventText.includes(e.key) &&
                  e.preventDefault()
              }
              }
              label={("")}
              placeholder={""}
              sizeval="medium"
              values={values?.linkApproval}
              onChange={(e) => {
                if (e.target.value <= 100) {
                  handleChange(e);
                } else {
                  e.preventDefault();
                }
              }}
              onBlur={handleBlur}
              error={
                Boolean(touched.linkApproval) &&
                errors.linkApproval
              }
              helperText={
                touched.linkApproval &&
                errors.linkApproval
              }
            />
          </Stack>
        </Stack>
        {errors.totalMilestone && touched.totalMilestone && (
          <Box border={1} borderRadius={2} p={1} borderColor={"red"} color={"red"}>
            <Typography variant="body" gutterBottom >
              Note : If you are opting for milestone based payments, please ensure that the total percentage combined in the fields that you have entered the value are amounting to 100%.
            </Typography>
          </Box>
        )}
      </Box>)}
      {
        values.type === CAMPAIGN_TYPES.AFFILIATE && <>
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#2B2829', textTransform: 'uppercase', paddingY: '24px' }}>
              Key Performance Indicators (KPI)
            </Typography>
          </Grid>
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <Typography mb={1} gutterBottom>
              <FormLabel sx={{ fontSize: '14px', fontWeight: 500, color: '#2B2829', textTransform: 'capitalize' }} required>{values.eventType ? values.eventType?.replaceAll("_", " ") : "Event Program 1"}</FormLabel>
            </Typography>
            <NumberInput
              startAdornmentText={<InputAdornment position="start"><CurrencyRupeeIcon /></InputAdornment>}
              startAdornment={true}
              placeholder={"Event Program 1"}
              name={"eventProgramPrice"}
              isRequired={false}
              type={"number"}
              focused={false}
              label={("")}
              style={{ width: "50%" }}
              sizeval="medium"
              values={values.eventProgramPrice}
              onChange={(e) => {
                if (e.target.value.length <= 10) {
                  handleChange(e);
                } else {
                  e.preventDefault();
                }
              }}
              onBlur={handleBlur}
              error={Boolean(touched.eventProgramPrice) && errors.eventProgramPrice}
              helperText={touched.eventProgramPrice && errors.eventProgramPrice}
            />
          </Grid>
        </>
      }
      {
        values.type === CAMPAIGN_TYPES.PERFORMANCE && <>
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#2B2829', textTransform: 'uppercase', paddingY: '24px' }}>
              Key Performance Indicators (KPI)
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <div className="row g-4">
              <div className="col-xl-6  col-12">
                <div className="keyPerfindi">
                  <FormControlLabel control={<Radio checked={values.costPer === "costPerShare"} name="costPer"
                    value={"costPerShare"}
                    onChange={(e) => {
                      handleChange(e);
                      handleChange({
                        target: {
                          name: "costPerLinkClick",
                          value: ""
                        }
                      })
                      handleChange({
                        target: {
                          name: "costPerView",
                          value: ""
                        }
                      })
                      handleChange({
                        target: {
                          name: "costPerEngagement",
                          value: ""
                        }
                      })
                    }} size="small" />} label="Cost per Share" />
                  <NumberInput
                    startAdornmentText={<InputAdornment position="start"><CurrencyRupeeIcon /></InputAdornment>}
                    startAdornment={true}
                    placeholder={"Cost per Share"}
                    name={"costPerShare"}
                    isDisabled={values.costPer !== "costPerShare"}
                    isRequired={false}
                    type={"number"}
                    focused={false}
                    label={("")}
                    style={{ width: "50%" }}
                    sizeval="medium"
                    values={values.costPerShare}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        handleChange(e);
                      } else {
                        e.preventDefault();
                      }
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.costPerShare) && errors.costPerShare}
                    helperText={touched.costPerShare && errors.costPerShare}
                  />
                </div>
              </div>
              <div className="col-xl-6  col-12">
                <div className="keyPerfindi">
                  <FormControlLabel control={<Radio checked={values.costPer === "costPerLinkClick"} size="small" name="costPer"
                    value={"costPerLinkClick"}
                    onChange={(e) => {
                      handleChange(e);
                      handleChange({
                        target: {
                          name: "costPerShare",
                          value: ""
                        }
                      })
                      handleChange({
                        target: {
                          name: "costPerView",
                          value: ""
                        }
                      })
                      handleChange({
                        target: {
                          name: "costPerEngagement",
                          value: ""
                        }
                      })
                    }} />} label="Cost per Link clicks" />
                  <NumberInput
                    startAdornmentText={<InputAdornment position="start"><CurrencyRupeeIcon /></InputAdornment>}
                    startAdornment={true}
                    placeholder={"Cost per Link clicks"}
                    name={"costPerLinkClick"}
                    isDisabled={values.costPer !== "costPerLinkClick"}
                    isRequired={false}
                    type={"number"}
                    focused={false}
                    label={("")}
                    style={{ width: "50%" }}
                    sizeval="medium"
                    values={values.costPerLinkClick}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        handleChange(e);
                      } else {
                        e.preventDefault();
                      }
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.costPerLinkClick) && errors.costPerLinkClick}
                    helperText={touched.costPerLinkClick && errors.costPerLinkClick}
                  />
                </div>
              </div>
              <div className="col-xl-6  col-12">
                <div className="keyPerfindi">
                  <FormControlLabel checked={values.costPer === "costPerView"} value={values.costPer} control={<Radio name="costPer"
                    value={"costPerView"}
                    onChange={(e) => {
                      handleChange(e);
                      handleChange({
                        target: {
                          name: "costPerShare",
                          value: ""
                        }
                      })
                      handleChange({
                        target: {
                          name: "costPerLinkClick",
                          value: ""
                        }
                      })
                      handleChange({
                        target: {
                          name: "costPerEngagement",
                          value: ""
                        }
                      })
                    }} size="small" />} label="Cost per View" />
                  <NumberInput
                    startAdornmentText={<InputAdornment position="start"><CurrencyRupeeIcon /></InputAdornment>}
                    startAdornment={true}
                    placeholder={"Cost per view"}
                    name={"costPerView"}
                    isDisabled={values.costPer !== "costPerView"}
                    isRequired={false}
                    type={"number"}
                    focused={false}
                    label={("")}
                    style={{ width: "50%" }}
                    sizeval="medium"
                    values={values.costPerView}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        handleChange(e);
                      } else {
                        e.preventDefault();
                      }
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.costPerView) && errors.costPerView}
                    helperText={touched.costPerView && errors.costPerView}
                  />
                </div>
              </div>
              <div className="col-xl-6  col-12">
                <div className="keyPerfindi">
                  <div className="labeling">
                    <FormControlLabel control={<Radio checked={values.costPer === "costPerEngagement"} name="costPer"
                      value={"costPerEngagement"}
                      onChange={(e) => {
                        handleChange(e);
                        handleChange({
                          target: {
                            name: "costPerShare",
                            value: ""
                          }
                        })
                        handleChange({
                          target: {
                            name: "costPerLinkClick",
                            value: ""
                          }
                        })
                        handleChange({
                          target: {
                            name: "costPerView",
                            value: ""
                          }
                        })
                      }} size="small" />} label="Cost per Engagement" />
                    <Tooltip arrow title="Like, Comment, Share, Save" placement="top"><InfoIcon fontSize='small' color="secondary" /></Tooltip>
                  </div>
                  <NumberInput
                    startAdornmentText={<InputAdornment position="start"><CurrencyRupeeIcon /></InputAdornment>}
                    startAdornment={true}
                    placeholder={"Cost per Engagement"}
                    name={"costPerEngagement"}
                    isDisabled={values.costPer !== "costPerEngagement"}
                    isRequired={false}
                    type={"number"}
                    focused={false}
                    label={("")}
                    style={{ width: "50%" }}
                    sizeval="medium"
                    values={values.costPerEngagement}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        handleChange(e);
                      } else {
                        e.preventDefault();
                      }
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.costPerEngagement) && errors.costPerEngagement}
                    helperText={touched.costPerEngagement && errors.costPerEngagement}
                  />
                </div>
              </div>
            </div>
          </Grid>
        </>
      }
    </>
  )
}
const SectionSix = ({ dispatch, handleChange, errors, values, setFieldValue, touched, handleBlur }) => {
  const { referenceContentUrl } = useSelector((state) => state.campaignSlice);
  const [preview, setPreview] = useState(values?.referenceContentUrl || null);
  const [bannerVideoError, setBannerVideoError] = useState("");
  const [openVideoPlaybackModal, setOpenVideoPlaybackModal] = useState(false);
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
    e.target.value = null;
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    handleFile(file);
    e.target.value = null;
  };
  const handleFile = async (file) => {
    if (!file) return;
    const videoElement = document.createElement('video');
    videoElement.preload = 'metadata';
    setBannerVideoError('');
    videoElement.onloadedmetadata = function () {
      window.URL.revokeObjectURL(videoElement.src);
      const width = videoElement.videoWidth;
      const height = videoElement.videoHeight;
      const aspectRation = width / height;
      const targetRatio = 9 / 16;
      const tolerance = 0.01;
      if (Math.abs(aspectRation - targetRatio) > tolerance) {
        setBannerVideoError(`Supported dimensions for video aspect ratios include 9:16 (smartphone screen size). please provide valid ratio video`);
        return;
      }
      handleChange({
        target: {
          name: "videofileName",
          value: file?.name || "",
        },
      });
      dispatch(
        updateCampaign({
          referenceContentUrl: "",
        })
      );
      dispatch(
        getPresignedurl(
          file?.name,
          file?.type?.split(
            "/"
          )[1],
          file,
          (url) => {
            handleChange({
              target: {
                name: "referenceContentUrl",
                value: url || "",
              },
            });
            setPreview(url)
          }
        )
      );
      setFieldValue(
        "referenceContentUrl",
        (referenceContentUrl || "")
      );
    }
    videoElement.src = URL.createObjectURL(file);
  };
  const handleDeleteBannerImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleChange({
      target: {
        name: "bannerImage",
        value: "",
      }
    })
    handleChange({
      target: {
        name: "bannerImageBase64",
        value: null,
      }
    })
    setPreview(null);
  }
  return (
    <>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color: 'black', paddingBottom: '0px', marginTop: '24px' }}>Additional  Requirements</Typography>
      <Box sx={{ padding: '24px', border: '1px solid #F0F0F0', borderRadius: '10px', marginTop: '24px' }}>
        <Stack direction="column" gap={3}>   <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C' }}>Account Mentions</Typography>
          <Box sx={{ width: '48%' }}>
            <NormalInput
              name={"accountMentions"}
              type={"text"}
              isRequired={false}
              focused={false}
              label={""}
              sizeval="medium"
              values={values?.accountMentions}
              placeholder={"@mentionname @mention2"}
              onChange={handleChange}
              onBlur={handleBlur}
              style={FORM_INPUTFIELD_STYLES}
              error={
                Boolean(touched?.accountMentions) &&
                errors?.accountMentions
              }
              helperText={
                touched?.accountMentions &&
                errors?.accountMentions
              }
            />
          </Box>
        </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C' }}>Campaign Hashtags <Tooltip placement='top' title={<p>"Enter '#' to start writing a hashtag and enter your string without any spaces. Hashtags can only contain letters, numbers, and underscores (_).<br></br>Add a space (without any comma or semicolon) to complete the last hashtag and enter '#' again to add a new hashtag following the last one.<br></br> Example: #CampaignTest1 #CampaignTest2 #CampaignTest3"</p>}><img src={infoIcon} alt="infoicon" style={{ height: '16px', width: '16px' }} /></Tooltip></Typography>
            <Box sx={{ width: '48%' }}>
              <NormalInput
                name={"campaignHashtag"}
                type={"text"}
                isRequired={false}
                focused={false}
                label={""}
                sizeval="medium"
                style={FORM_INPUTFIELD_STYLES}
                values={values?.campaignHashtag}
                placeholder={"#brand_name #mention2"}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  Boolean(touched?.campaignHashtag) &&
                  errors?.campaignHashtag
                }
                helperText={
                  touched?.campaignHashtag &&
                  errors?.campaignHashtag
                }
              />
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box sx={{ width: '48%' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                Add Reference
              </Typography>
              <Box
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                sx={{
                  border: '1px dashed #E5E5E5',
                  borderRadius: '16px',
                  padding: '16px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  background: '#FAFAFA',
                  position: 'relative',
                  width: '100%', height: '150px'
                }}
              >
                <input
                  type="file"
                  accept="video/*"
                  id="fileInput"
                  style={{ display: 'block', height: '100%', width: '100%', border: '2px solid red', opacity: 0 }}
                  onChange={handleFileChange}
                />
                <label htmlFor="fileInput" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, padding: '16px', cursor: 'pointer' }}>
                  {preview ? (
                    <Stack
                      direction="row" justifyContent="flex-start" gap={0} alignItems="center"
                      sx={{
                        width: '100%',
                        height: '100%',
                        borderRadius: 2,
                        border: '0px solid red'
                      }}
                    >
                      <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={2} sx={{ height: '100px', width: '350px', background: '#F0F0F0', borderRadius: '10px', padding: '14px' }}>
                        <Box sx={{ height: '65px', width: '65px', position: 'relative' }}>
                          <video src={preview} alt="preview" style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '5px' }} />
                          <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpenVideoPlaybackModal(true) }} style={{ position: 'absolute', top: 0, left: 0, background: 'rgba(0,0,0,0.5)', height: '100%', width: '100%', padding: '17px', borderRadius: '5px' }}>
                            <img src={playIconWhite} alt="imageIconWhite" style={{ height: '24px', width: '24px' }} />
                          </div>
                        </Box>
                        <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400, minWidth: '200px', textAlign: 'left' }}>{values?.videofileName?.substring(0, 30) || "Refrence Video"}</Typography>
                        <img src={check} alt="check" style={{ height: '24px', width: '24px' }} />
                      </Stack>
                      <Button sx={{ "&:hover": { background: 'transparent' } }} disableRipple onClick={handleDeleteBannerImage}><img src={deleteIconRed} alt="check" style={{ height: '24px', width: '24px' }} /></Button>
                    </Stack>
                  ) : (
                    <>
                      <img src={videoModalIcon} alt="" style={{ height: '32px', width: '32px' }} />
                      <Typography variant="body1" sx={{ mt: 0.7, fontSize: '12px', fontWeight: 600 }}>
                        <span style={{ color: 'var(--color-blue)', textDecoration: 'underline', }}>
                          Click to upload
                        </span>{' '}
                        or drag and drop
                      </Typography>
                      <Typography variant="caption" sx={{ mt: 0.7, display: 'block', color: '#A3A3A3', fontSize: '10px', fontWeight: 400, }}>
                        Supported dimensions for video aspect ratios include 9:16 (smartphone screen)
                      </Typography>
                      {bannerVideoError && (<Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}>
                        {bannerVideoError}
                      </Typography>)}
                    </>
                  )}
                </label>
              </Box>
            </Box>
            <Box sx={{ width: '48%' }} className="campaignModal">
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                Reference Content
              </Typography>
              <Editor
                value={values?.referenceContent || ""}
                onChange={(e) => {
                  handleChange({
                    target: {
                      name: "referenceContent",
                      value: e.target?.value || "",
                    },
                  });
                }}
                style={{ height: '150px !important' }}
              >
              </Editor>
            </Box>
          </Stack>
        </Stack>
        <Box sx={{ paddingY: '32px' }}>
          <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'black', borderBottom: '0px solid #F0F0F0', textTransform: 'uppercase' }}>Contact Details <span style={{ color: 'var(--red)' }}>*</span></Typography>
          <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#726C6C', paddingBottom: '24px', borderBottom: '0px solid #F0F0F0' }}>Sharing your phone number will help us reach you faster, we won't spam you.</Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', borderBottom: '0px solid #F0F0F0', paddingBottom: '5px' }}>Phone No.</Typography>
          <NumberInput
            name={"contactDetails"}
            type={"number"}
            isRequired={false}
            focused={false}
            style={FORM_INPUTFIELD_STYLES}
            label={""}
            sizeval="medium"
            values={values?.contactDetails}
            placeholder={"Enter your phone number"}
            onChange={(e) => {
              if (e.target.value.length <= 10) {
                handleChange(e);
              } else {
                e.preventDefault();
              }
            }}
            onBlur={handleBlur}
            error={
              Boolean(touched.contactDetails) &&
              errors.contactDetails
            }
            helperText={
              touched.contactDetails &&
              errors.contactDetails
            }
          />
        </Box>
      </Box>
      <VideoplaybackDialogForCampaignModal preview={preview} open={openVideoPlaybackModal} setOpen={setOpenVideoPlaybackModal} />
    </>
  )
}
const SectionSeven = ({ dispatch, values, formData, influncersListForCampaign = [], setIsInfluncersDeletedFromCampaign, isInfluncersDeletedFromCampaign }) => {
  const { brandsDropdown } = useSelector(state => state.brandSlice);
  const [deleteInfluncersFromCampaign] = useDeleteInfluncersFromCampaignMutation();
  const updateFormData = (row) => {
    dispatch(getCampaignByIdForDetailsPage(row.campaignId, (data) => {
      delete data.campaignContent;
      delete data.applied;
      delete row.applied;
      let rowData = data;
      rowData.campaignId = row.id;
      const selectedDeliverables = rowData?.deliverables?.length > 0 ? (rowData?.deliverables[0]?.plateform == "youtube" ? SELECTED_DELI_FOR_YOUTUBE : SELECTED_DELI).map((vv) => {
        let val = data?.deliverables?.map((v) => v.deliverables)[0]?.find((v) => v?.type == vv?.type);
        if (val) {
          return { ...val };
        }
      }) : [];
      rowData.platform = rowData?.deliverables?.length > 0 ? rowData?.deliverables[0]?.plateform : "";
      rowData.selectedDeliverables = rowData?.deliverables?.length > 0 ? selectedDeliverables.filter((item) => item) : [];
      rowData.post = rowData?.deliverables?.length > 0 ? data?.deliverables[0]?.post : [];
      rowData.deliverables = rowData?.deliverables?.length > 0 ? DELIVERABLES_DATA.find((v) => v[`${rowData.deliverables[0].plateform}`])[`${rowData.deliverables[0].plateform}`] : [];
      rowData.brandId = row?.brandId || rowData?.brand?.id || '';
      rowData.additionalRequirement = rowData.additionalRequirement !== "null" ? rowData.additionalRequirement : "";
      rowData.startDate = rowData.startDate ? formatDate(rowData.startDate) : null;
      rowData.endDate = rowData.endDate ? formatDate(rowData.endDate) : null;
      rowData.budgetbudgetPerInfluencer = rowData.budgetPerInfluencer;
      rowData.gender = rowData?.creator?.gender || "";
      rowData.creatorLocation = rowData?.creator?.creatorLocation || '';
      rowData.influncerType = rowData?.creator?.influncerType || [];
      rowData.selectedCategories = rowData?.creator?.selectedCategories || [];
      rowData.campaignApplyingPreferences = rowData?.creator?.campaignApplyingPreferences ? ['campaignApplyingPreferences'] : [];
      rowData.noOfCreators = String(rowData?.noOfCreators || "");
      rowData.bannerImage = rowData?.bannerImage?.toString() || '';
      rowData.shipmentDetails = rowData.shipmentDetails ? ['shipmentDetails'] : []
      rowData.productShipmentDate = rowData.productShipmentDate && rowData.productShipmentDate !== "0000-00-00" ? formatDate(rowData.productShipmentDate) : "";
      rowData.conceptScriptDate = rowData?.conceptScriptDate ? formatDate(rowData?.conceptScriptDate) : null;
      rowData.contentSubmissionDate = rowData?.contentSubmissionDate ? formatDate(rowData?.contentSubmissionDate) : null
      rowData.contentPublishDate = rowData?.contentPublishDate ? formatDate(rowData?.contentPublishDate) : null;
      rowData.mode = "edit";
      rowData.applyBydate = rowData?.applyBydate ? formatDate(rowData?.applyBydate) : null;
      rowData.productDropdown = brandsDropdown?.find((v) => v.id === rowData.brandId)?.product?.map((v) => v?.name) || [];
      dispatch(updateCampaign({ affliateSection: 0, deliverablesSection: 0, addtionalSection: 0, detailsSection: 0, formData: rowData }));
    }))
  }
  const handleDeleteInfluncersFromCampaign = async () => {
    try {
      const res = await deleteInfluncersFromCampaign({ campaignId: formData?.campaignId, }).unwrap();
      if (res.status === "SUCCESS") {
        setIsInfluncersDeletedFromCampaign(true);
      } else {
      }
    } catch (error) {
    }
  }
  useEffect(() => {
    updateFormData(values)
  }, [])
  const statusUI = (status) => {
    switch (status) {
      case 'DRAFT':
        return {
          color: '#726C6C', background: '#F0F0F0',
        }
      case 'COMPLETED':
      case 'APPROVED':
      case 'LIVE':
        return {
          color: '#22c55e', background: 'rgba(34, 197, 94, 0.10)',
        }
      case 'EXPIRED':
      case 'BACKLISTED':
        return {
          color: '#ef3f3f', background: 'rgba(239, 63, 63, 0.10)',
        }
      case 'UNPUBLISHED':
      case 'REVIEW':
      case 'PENDING':
        return {
          color: '#e9c60d', background: 'rgba(255, 217, 15, 0.10)',
        }
      default:
        return {
          color: '#726C6C', background: '#F0F0F0',
        }
    }
  }
  let bannerBase64 = "";
  try {
    bannerBase64 = JSON.parse(values?.bannerImageBase64 || "{}").base64 || "";
  } catch (e) {
  }
  return (
    <>
      <Stack direction="row" justifyContent="flex-start" gap={0}>
        <Box sx={{ width: '35%', border: '0px solid red' }}>
          {(values?.influencersAddedFromWishlistCount > 0 && !isInfluncersDeletedFromCampaign) && <Box sx={{
            borderRadius: '10px', padding: '0px', border: '0px solid red', marginBottom: '20px', width: '100%', height: '70px', position: 'relative', background: `url(${campaignInfluncerListBackground})`, backgroundSize: 'cover', // or 'contain'
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}>
            <Stack direction="row" justifyContent="space-evenly" alignItems="center" sx={{ height: '100%', width: '100%' }}>
              <Stack direction="row" justifyContent="flex-start" gap={1} alignItems="center">
                <Avatar src={values?.brand?.brandImage || ""} sx={{ height: '50px', width: '50px' }} /><Typography sx={{ fontSize: '20px', fontWeight: 600, }}>{values?.influencersAddedFromWishlistCount} <span style={{ fontSize: '16px', fontWeight: 500, color: '#726C6C' }}>Influencers</span></Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-evenly" gap={1}>
                <Box sx={{ padding: '4px', background: 'white', borderRadius: '10px', }}>
                  <img src={PLATFORMS_IMGS_LIST[capitalizeFirstLetter('Instagram')]} alt={values?.platform} style={{ height: '24px', width: '24px' }} />
                </Box>
                <Box sx={{ padding: '4px', background: 'white', borderRadius: '10px', marginLeft: '-20px' }}>
                  <img src={PLATFORMS_IMGS_LIST[capitalizeFirstLetter("Youtube")]} alt={values?.platform} style={{ height: '24px', width: '24px' }} />
                </Box>
              </Stack>
              <Box sx={{ padding: '10px', background: 'white', borderRadius: '4px', gap: '10px', display: 'flex', flexDirection: 'row', boxShadow: '0px 0px 29px 0px rgba(0, 0, 0, 0.10)' }}>
                <Button sx={{ padding: 0, margin: 0, height: 'fit-content', width: 'fit-content', minWidth: 0 }} disableRipple onClick={(e) => { e.stopPropagation(); handleDeleteInfluncersFromCampaign() }}><img src={deleteIconRed} alt="delete" style={{ height: '20px', width: '20px' }} />
                </Button>
                <Button sx={{ padding: 0, margin: 0, height: 'fit-content', width: 'fit-content', minWidth: 0 }} disableRipple onClick={(e) => { e.stopPropagation(); }}><img src={editIcon} alt="delete" style={{ height: '20px', width: '20px' }} /></Button>
              </Box>
            </Stack>
          </Box>}
          <Box sx={{ width: '100%', height: '200px', position: 'relative', }}>
            <img src={values?.bannerImage || bannerBase64} alt="bannerImage" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <Box sx={{ position: 'absolute', bottom: '-20%', left: '50%', transform: 'translateX(-50%)', height: '100px', width: '100px', borderRadius: '50%' }}>
              <Avatar src={values?.brand?.brandImage || ""} sx={{ height: '100%', width: '100%', }} />
            </Box>
          </Box>
          <Stack direction="column" justifyContent="end" alignItems="center" sx={{ height: '120px', border: '1px solid #F0F0F0', borderTop: 0, }}>
            <Typography sx={{ fontSize: '20px', fontWeight: 500, color: 'black' }}>{formData.name}</Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: 400, color: 'black', paddingBottom: '10px' }}><span style={{ fontWeight: '500' }}>Brand:</span> {values.brandName}</Typography>
          </Stack>
          <Box sx={{ borderRight: '1px solid #F0F0F0', paddingRight: '10px' }}>
            <Box sx={{ paddingY: '20px', }}>
              <Typography sx={{ fontSize: '16px', fontWeight: 600, color: 'black', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingBottom: '20px', }}><img src={fileIcon} alt="" style={{ filter: "brightness(0) invert(0)", height: '20px', width: '20px' }} />&nbsp;Campaign Brief:</Typography>
              <ExpandableText text={values.brief} limit={150} />
            </Box>
            <Stack direction="row" justifyContent="space-between" alignContent="center" sx={{ paddingBottom: '20px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Platform</Typography>
              <img src={PLATFORMS_IMGS_LIST[capitalizeFirstLetter(values?.platform)]} alt={values?.platform} style={{ height: '24px', width: '24px' }} />
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Start Date</Typography>
              <Typography sx={{ textAlign: 'right', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%' }}>{values.startDate}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Apply by Date:</Typography>
              <Typography sx={{ textAlign: 'right', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%' }}>{values.applyBydate}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>End Date</Typography>
              <Typography sx={{ textAlign: 'right', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%' }}>{values.startDate}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Contact Details</Typography>
              <Typography sx={{ textAlign: 'right', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%' }}>{values.contactDetails}</Typography>
            </Stack>
            <Box sx={{ borderTop: '1px solid #F0F0F0' }}>
              <Typography style={{ fontSize: '14px', fontWeight: 600, color: '#726C6C', padding: '10px 0 10px 0', textTransform: 'uppercase' }}>MileStone</Typography>
              <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Advance payment</Typography>
                <Typography sx={{ textAlign: 'right', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%' }}>{values.advancePayment}%</Typography>
              </Stack>
              <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Script Approval</Typography>
                <Typography sx={{ textAlign: 'right', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%' }}>{values.scriptApproval}%</Typography>
              </Stack>
              <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Content Approval</Typography>
                <Typography sx={{ textAlign: 'right', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%' }}>{values.contentApproval}%</Typography>
              </Stack>
              <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Publish link Approval</Typography>
                <Typography sx={{ textAlign: 'right', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%' }}> {values.linkApproval}%</Typography>
              </Stack>
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: '65%', padding: '0px 0 0px 0px', }}>
          <Box sx={{ paddingLeft: '32px', borderBottom: '1px solid #F0F0F0' }}>
            <Typography sx={{ fontSize: '16px', fontWeight: 600, color: 'black', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingBottom: '16px', }}><img src={fileEditIcon} alt="" style={{ filter: "brightness(0) invert(0)", height: '20px', width: '20px' }} />&nbsp;Campaign Details:</Typography>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Status</Typography>
              <Box sx={{ width: '50%' }}><Typography sx={{ textAlign: 'right', fontSize: '12px', fontWeight: 600, width: 'fit-content', borderRadius: '50px', padding: '4px 8px', ...statusUI(values.status), textTransform: "capitalize" }} ><span style={{ height: '8px', width: '8px', borderRadius: '50%', display: 'inline-block', background: statusUI(values.status)?.color }}></span> &nbsp;{values.status || "DRAFT"}</Typography></Box>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Campaign type:</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values.type}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Deliverables:</Typography>
              <List sx={{ width: '50%', padding: 0 }}>
                {values?.selectedDeliverables?.map((item, index) => (
                  <ListItem sx={{ padding: 0 }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 400, wordBreak: 'break-all', }}>
                      {`${index + 1}. ${item?.post} `}
                      ({item?.type} x {item?.qty})
                    </Typography>
                  </ListItem>
                ))}
              </List>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Products:</Typography>
              <List sx={{ width: '50%', padding: 0 }}>
                {values?.products?.map((item, index) => (
                  <ListItem sx={{ padding: 0 }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 400, wordBreak: 'break-all', }}>
                      {`${index + 1}. ${item.name} `}
                      <a target="_blank" rel="noreferrer" href={item.link} style={{ color: 'var(--color-blue)', textDecoration: 'none' }}>{item.link.substring(0, 50)}</a>
                    </Typography>
                  </ListItem>
                ))}
              </List>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Campaign Categories:</Typography>
              <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1} flexWrap="wrap" sx={{ width: '50%' }}>
                {values.selectedCategories?.map((cat) => (
                  <Tooltip arrow componentsProps={{
                    tooltip: {
                      sx: {
                        border: "0px solid var(--color-blue) !important",
                        marginTop: '3px !important',
                        backgroundColor: "#726C6C !important",
                        color: "white !important",
                        borderRadius: '5px',
                        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                        padding: '5px !important',
                        display: cat.length > 15 ? "block" : "none"
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#726C6C !important",
                        "&::before": {
                          backgroundColor: "#726C6C",
                        },
                      },
                    },
                  }} title={cat}>
                    <Chip
                      key={cat}
                      label={cat.length > 15 ? cat.substring(0, 15) + '...' : cat}
                      sx={{
                        background: 'white !important', color: '#726C6C !important',
                        borderRadius: '62px', border: '1px solid #CCCBCB', fontSize: '14px', fontWeight: '500',
                        padding: "1px 5px",
                        "&: p": { padding: 0 }
                      }}
                    /></Tooltip>
                ))}
              </Stack>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Campaign Hashtag</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, width: '50%', color: 'var(--color-blue)' }}> {values.campaignHashtag}</Typography>
            </Stack>
          </Box>
          <Box sx={{ paddingLeft: '32px', borderBottom: '1px solid #F0F0F0' }}>
            <Typography style={{ fontSize: '14px', fontWeight: 600, color: '#726C6C', padding: '20px 0 10px 0', textTransform: 'uppercase' }}>Campaign Budget</Typography>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Campaign Budget:</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> ₹{values.budget}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Budget Per Influencer:</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> ₹{values.budgetPerInfluencer}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>No of creators</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values.noOfCreators}</Typography>
            </Stack>
          </Box>
          <Box sx={{ paddingLeft: '32px', borderBottom: '1px solid #F0F0F0' }}>
            <Typography style={{ fontSize: '14px', fontWeight: 600, color: '#726C6C', padding: '20px 0 10px 0', textTransform: 'uppercase' }}>Content Date</Typography>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Script Date</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values.conceptScriptDate}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Submission Date</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values.contentSubmissionDate}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Product Shipment Date</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values.productShipmentDate}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Publish date</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values.contentPublishDate}</Typography>
            </Stack>
          </Box>
          <Box sx={{ paddingLeft: '32px', }}>
            <Typography style={{ fontSize: '14px', fontWeight: 600, color: '#726C6C', padding: '20px 0 10px 0', textTransform: 'uppercase' }}>Type</Typography>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Influencer type:</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values?.influncerType?.join(", ")}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Gender</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values?.gender}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Account Mentions</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values?.accountMentions}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignContent="center" sx={{ paddingBottom: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'black', width: '50%' }}>Apply By</Typography>
              <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 400, color: 'black', width: '50%', textTransform: 'capitalize' }}> {values?.campaignApplyingPreferences?.length > 0 ? "Anyone" : "Only Selected Influncers"}</Typography>
            </Stack>
          </Box>
        </Box>
      </Stack>
      {(values?.referenceContent || values?.referenceContentUrl) && <Typography sx={{ fontSize: '16px', fontWeight: 600, color: 'black', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingTop: '20px', }}>Reference Content</Typography>
      }<ExpandableText text={values?.referenceContent ? values?.referenceContent : ""} limit={300} />
      {values?.referenceContentUrl && <Box sx={{ width: '335px', height: '460px', borderRadius: '10px', paddingTop: '10px', }}><video alt="preview" style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10px' }} controls src={values?.referenceContentUrl}></video></Box>}
    </>
  )
}
const CustomDropdownIcon = ({ open, ...props }) => {
  return (
    <div {...props} style={{ padding: '0', marginRight: '10px' }}>
      <img src={rightCaret} alt="caret" style={{ height: '20px', width: '20px', rotate: '90deg', marginTop: !open ? '-5px' : 0 }} />
    </div>
  )
};
const ExpandableText = ({ text, limit = 100 }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  const plainText = text.replace(/<[^>]+>/g, '');
  const isLong = plainText.length > limit;
  let truncatedHtml = text;
  if (!expanded && isLong) {
    const truncatedPlain = plainText.substring(0, limit).trim();
    truncatedHtml = `<span>${truncatedPlain}...</span>`;
  }
  return (
    <Typography
      sx={{
        fontSize: '14px',
        fontWeight: 400,
        color: '#474747',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}
    >
      <span
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(expanded ? text : truncatedHtml),
        }}
      />
      {isLong && (
        <Button
          variant="text"
          size="small"
          disableRipple
          sx={{
            ml: 0.5,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
            '&:hover': { background: 'none' },
            p: 0,
          }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'See Less' : 'See More'}
        </Button>
      )}
    </Typography>
  );
};
const Schedular = ({ formData, values, handleChange, setCampaignStage }) => {
  return (
    <>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color: 'black', paddingBottom: '0px', marginTop: '24px' }}>Campaign Dates*</Typography>
      <Box sx={{ padding: '24px', border: '1px solid #F0F0F0', borderRadius: '10px', marginTop: '24px' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width={"100%"}>
          <Typography fontSize={16} fontWeight={500} color={"#726C6C"}>Select Start & End dates of campaign</Typography>
          <Stack sx={{ border: '1px solid #F0F0F0', padding: '6px', borderRadius: '4px', display: 'none' }} direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1}>
            <Button sx={{ border: '1px solid #F0F0F0', padding: '2px', borderRadius: '4px' }}><Typography>Week</Typography></Button>
            <Button sx={{ border: '1px solid #F0F0F0', padding: '2px', borderRadius: '4px' }}><Typography>Months</Typography></Button>
            <Button sx={{ border: '1px solid #F0F0F0', padding: '2px', borderRadius: '4px' }}><Typography>Today</Typography></Button>
          </Stack>
        </Stack>
        <Box sx={{ padding: '0px', border: '1px solid #F0F0F0', borderRadius: '10px', marginTop: '24px' }}>
          <DynamicTable formData={formData} values={values} handleChange={handleChange} setCampaignStage={setCampaignStage} />
        </Box>
      </Box></>
  )
}
const DynamicTable = ({ formData, values, handleChange, setCampaignStage }) => {
  const weeks = getWeeks(values.startDate, values.endDate)
  const allDates = weeks.flat();
  const headingRow = [
    "Start & End date",
    "Apply by Date",
    "Submit Script Date",
    "Submit Content Date",
    "Publish Content Date"
  ];
  const schedularMapingKeys = {
    "Start & End date": {
      backgroundColor: "#CAF2D7", borderColor: '#5FD28C', heading: 'Campaign Starting ', dateKeys: ["startDate", "endDate"], minDate: formData.mode === "edit" && formData?.status !== DRAFT
        ? values?.startDate || formatDate(new Date())
        : formatDate(new Date(), "dd/mm/yyyy")
    },
    "Apply by Date": { backgroundColor: "#FFE0E3", borderColor: '#ED7172', heading: 'Apply by', dateKeys: ["applyBydate",], minDate: values?.startDate, maxDate: values.endDate },
    "Submit Script Date": { backgroundColor: "#DBECFF", borderColor: '#0077FF', heading: 'Script', dateKeys: ["conceptScriptDate",], minDate: values?.applyBydate, maxDate: values?.endDate, subheading: '(Max time for Script submission after applying in campaign)', },
    "Submit Content Date": { backgroundColor: "#F0F0F0", borderColor: '#726C6C', heading: 'Content', dateKeys: ["contentSubmissionDate",], minDate: values?.conceptScriptDate, maxDate: values?.endDate, subheading: '(Max time for Content submission after you approve the script)', },
    "Publish Content Date": { backgroundColor: "#FFE4DB", borderColor: '#FE5D26', heading: 'Publish link', dateKeys: ["contentPublishDate",], minDate: values?.contentSubmissionDate, maxDate: values?.endDate, subheading: '(Max time for Content publishing after you approve the content)', },
  };
  const dateRanges = [
    { start: values.startDate, end: values.endDate },
    { start: values.startDate, end: values.applyBydate },
    { start: values.startDate, end: values.conceptScriptDate },
    { start: values.startDate, end: values.contentSubmissionDate },
    { start: values.startDate, end: values.contentPublishDate }
  ];
  const today = dayjs().format("YYYY-MM-DD"); // Get today's date
  const todayIndex = allDates.findIndex(d => d === today); // Find index in grid
  return (
    <><Stack direction={"row"} gap={0} sx={{ border: '0px solid red', width: '100%', height: '100%' }}>
      <TableContainer sx={{
        overflowX: 'auto', borderRadius: '0px', overflowY: 'hidden', width: '30%', scrollbarWidth: 0, '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}>
        <Table sx={{ width: '100%', tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow sx={{ height: '30px', }}>
              <TableCell
                sx={{
                  borderBottom: '1px solid #F0F0F0', borderRight: '1px solid #F0F0F0',
                  width: '100%',
                  padding: '0px !important', background: '#FBFBFC !important'
                }}
              >
                <Typography fontSize={12} fontWeight={500} color={'#726C6C'}>
                  Select Campaign dates
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {headingRow.map((label, idx) => {
              const range = dateRanges[idx];
              return (
                <TableRow key={idx} sx={{ height: '55px' }}>
                  <TableCell
                    sx={{
                      borderBottom: '1px solid #F0F0F0', borderRight: '1px solid #F0F0F0',
                      height: '55px',
                      width: '100%',
                      verticalAlign: 'middle',
                    }}
                  >
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ height: '45px', border: '0px solid red', position: "relative", }}>
                      <Box>
                        <Typography fontSize={14} fontWeight={500} color="#25272D">
                          {label}
                        </Typography>
                        <Typography fontSize={10} pt={0.2} fontWeight={400} color='#726C6C'>
                          {schedularMapingKeys[label].subheading ? schedularMapingKeys[label].subheading : label === 'Apply by Date' ? (range.end ? dayjs(range.end).format('MMM-DD,YYYY') : '') : dayjs(range.start).format('MMM-DD') + " - " + dayjs(range.end).format('MMM-DD,YYYY')}
                        </Typography>
                      </Box>  {label !== 'Start & End date' ? <CustomDateInput handleChange={handleChange} startDate={range.start} endDate={range.end} names={schedularMapingKeys[label].dateKeys} minDate={schedularMapingKeys[label].minDate} maxDate={schedularMapingKeys[label].maxDate} /> : <Button sx={{ "&.hover": { background: 'none' } }} disableRipple onClick={() => setCampaignStage(prev => prev - 1)}><img src={edit} alt="edit" style={{ height: '24px', width: '24px' }} /></Button>}</Stack>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer sx={{
        overflowX: 'auto', borderRadius: '0px', overflowY: 'hidden', width: '70%', scrollbarWidth: 0, '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}>
        <Table sx={{
          tableLayout: 'fixed', borderRadius: '8px', overflowY: 'hidden', overflowX: 'scroll', width: '100%',
        }}>
          <TableHead>
            <TableRow sx={{ height: '30px', }}>
              {allDates.map((date, i) => {
                const isWeekEnd = dayjs(date).format("d") == 0;
                const isToday = i === todayIndex;
                const isFirstOrLastElement = (i === 0 || i === allDates.length - 1);
                const isSunOrSat = (dayjs(date).format("d") == 0 || dayjs(date).format("d") == 6)
                return (
                  <TableCell
                    key={i}
                    sx={{
                      width: isFirstOrLastElement ? '80px' : '30px',
                      borderRight: isWeekEnd ? '2px solid #F0F0F0' : undefined,
                      borderLeft: isToday ? '2px solid blue' : undefined, textAlign: i === 0 ? 'left' : 'center',
                      background: '#FBFBFC !important', padding: '0px !important',
                    }}
                  >
                    <Typography fontSize={12} fontWeight={500} color={'#726C6C'} sx={{ background: isSunOrSat ? '#E6E6E6' : 'transparent', padding: isSunOrSat ? '2px' : '0px', marginX: isSunOrSat ? '3px' : '0px', borderRadius: '2px' }}>
                      {dayjs(date).format(isFirstOrLastElement ? "MMM-DD" : "DD")}
                    </Typography>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {headingRow.map((label, rowIndex) => {
              const range = dateRanges[rowIndex];
              const startIndex = allDates.findIndex(d => dayjs(d).isSame(dayjs(range.start), 'day'));
              const endIndex = allDates.findIndex(d => dayjs(d).isSame(dayjs(range.end), 'day'));
              const span = endIndex >= startIndex ? endIndex - startIndex + 1 : 0;
              return (
                <TableRow key={rowIndex} sx={{ height: '55px', }}>
                  {Array.from({ length: allDates.length }).map((_, i) => {
                    const isWeekEnd = dayjs(allDates[i]).format("d") == 0;
                    const isToday = i === todayIndex;
                    if (i === startIndex) {
                      return (
                        <TableCell
                          key={i}
                          colSpan={span}
                          sx={{
                            padding: 0, minWidth: '80px', width: '80px',
                            borderRight: ((startIndex + span) % 7 === 0) ? '2px dashed #F0F0F0' : undefined,
                            borderLeft: isToday ? '2px solid blue' : undefined,
                          }}
                        >
                          {range.start && range.end ? <Tooltip
                            arrow
                            componentsProps={TOOLTIP_STYLES} placement="top" followCursor
                            title={<>
                              <Typography fontSize={12} fontWeight={500} color={"#726C6C"}>{schedularMapingKeys[label].heading}</Typography>
                              <Typography fontSize={10} fontWeight={400} color={"#726C6C"} >{dayjs(range.start).format('MMM-DD')} - {dayjs(range.end).format('MMM-DD,YYYY')}</Typography>
                            </>}> <div
                              style={{
                                height: '45px',
                                backgroundColor: schedularMapingKeys[label].backgroundColor || '#CAF2D7',
                                borderLeft: '3px solid',
                                borderColor: schedularMapingKeys[label].borderColor || '#5FD28C',
                                borderRadius: '4px', paddingLeft: '5px', display: 'flex', flexDirection: 'column', justifyContent: 'center', transition: 'all 1sec'
                              }}
                            >
                              <Typography fontSize={12} fontWeight={500} color={"#25272D"} textOverflow={"ellipsis"} whiteSpace={"nowrap"} overflow={"hidden"}>{schedularMapingKeys[label].heading}</Typography>
                              <Typography fontSize={10} fontWeight={400} color={"#726C6C"} textOverflow={"ellipsis"} whiteSpace={"nowrap"} overflow={"hidden"}>{dayjs(range.start).format('MMM-DD')} - {dayjs(range.end).format('MMM-DD,YYYY')}</Typography>
                            </div>  </Tooltip> : <div style={{ height: '45px' }}></div>}
                        </TableCell>
                      );
                    } else if (i > startIndex && i <= endIndex) {
                      return null;
                    } else {
                      return (
                        <TableCell
                          key={i}
                          sx={{
                            minWidth: '80px', width: '80px',
                            borderRight: isWeekEnd ? '2px dashed #F0F0F0' : undefined,
                            borderLeft: isToday ? '2px solid blue' : undefined,
                            backgroundColor: isToday ? '#e3f2fd' : undefined,
                          }} />
                      );
                    }
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
    </>
  );
};
const CustomDateInput = ({ startDate, endDate, handleChange, names = [], minDate, maxDate }) => {
  const [selectedRange, setSelectedRange] = useState([startDate, endDate || null])
  const isRange = names.length > 1;
  const ExampleCustomInput = forwardRef(
    ({ value, onClick, className, sx }, ref) => (
      <Button className={className} onClick={onClick} ref={ref} sx={sx} disableRipple>
        <img src={calenderIcon} alt="calenderIcon" style={{ height: '24px', width: '24px' }} />
      </Button>
    )
  )
  const handleDateRange = (date) => {
    setSelectedRange([date]);
    handleChange({
      target: {
        name: names[0],
        value: dayjs(date).format('YYYY-MM-DD')
      }
    })
  }
  return (
    <DatePicker
      portalId="root-portal"
      calendarClassName="vishal" selectsRange={isRange} monthsShown={1}
      startDate={isRange ? selectedRange[0] : undefined}
      endDate={isRange ? selectedRange[1] : undefined}
      selected={!isRange ? selectedRange[0] : undefined}
      onChange={handleDateRange}
      minDate={minDate}
      maxDate={maxDate || undefined}
      dateFormat={"yyyy-mm-dd"}
      enableTabLoop={false} customInput={<ExampleCustomInput sx={{ height: 'fit-content', width: 'fit-content', "&:hover": { background: 'none' } }} />} popperPlacement="bottom-center"
    />
  )
}
const getWeeks = (startDate, endDate) => {
  const weeks = [];
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  let current = start;
  let week = [];
  while (current.isBefore(end) || current.isSame(end)) {
    week.push(current.format("YYYY-MM-DD"));
    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }
    current = current.add(1, 'day');
  }
  if (week.length) {
    weeks.push(week);
  }
  return weeks;
};
